import React, { useEffect, useState } from "react";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { CircularProgress } from "@mui/material";
import { useShowAlert } from "../../../../../context/AlertContext";
import autoTable from "jspdf-autotable";
import jsPDF from "jspdf";
import InterRegular from "../../../sale/font/Inter_24pt-Regular-normal";
import InterBold from "../../../sale/font/Inter_24pt-Bold-normal";
import { useNetwork } from "../../../../../context/NetworkContext";
import AxiosInstance from "../../../../../utils/AxiosInstance";
import uRLs from "../../../../../utils/baseUtils";
import handleError from "../../../../../constants/handleError";
import { useAuth } from "../../../../../context/AuthProvider";
import { usePermission } from "../../../../../context/PermissionContext";
import NotoSansMonoReular from "../../../sale/font/NotoSansMono-Regular-normal";
import NotoSansMonoBold from "../../../sale/font/NotoSansMono-Bold-bold";
import axios from "axios";
import { getOS } from "../../../../../utils/getOs";
import { FormatedSaleData } from "../../../../../utils/print/GlobelSaleData";
import { DownloadIcon, PrinterIcon } from "../../../../../constants/Icons";

const Thermal_2 = ({
  isViewData,
  selectedTheme,
  selectedSize,
  downloadbtn = false,
}) => {
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const [download, setDownload] = useState(false);
  const [print, setPrint] = useState(false);
  const [data, setData] = useState({});
  const globalData = FormatedSaleData(data);
  const { settings } = useAuth();
  const { storeSettings } = usePermission();
  const [terms, setTerms] = useState([]);
  const sizeOptions = [
    { key: "BILL", label: "BILL" },
    { key: "INVOICE", label: "INVOICE" },
  ];
  const os = getOS();

  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "BILL":
        return "BILL RECIEPT";
      case "INVOICE":
        return "TAX INVOICE";
      default:
        return salemode;
    }
  };

  const saleDate = data?.saledate;
  const timezone = data?.saleby?.timezone;

  let saleTime = "--:--";
  if (saleDate) {
    const zoned = DateConverter.convertToTimeZone(saleDate, timezone);
    saleTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  let createdTime = "--:--";
  if (data?.createdAt) {
    const zoned = DateConverter.convertToTimeZone(data.createdAt, timezone);
    createdTime = DateConverter.ISOToDisplayFormat(zoned);
  }

  const handlePrintService = async (pdfBase64, printerName) => {
    try {
      const response = await axios.post(
        "http://127.0.0.1:9164/print/pdf",
        {
          pdfBase64,
          printerName,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return true;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }
  };

  const handlePrintSystem = async (pdfBase64, printerName) => {
    if (os === "Windows") {
      return await handlePrintService(pdfBase64, printerName);
    }
    return false;
  };

  const loadImageDimensions = (base64Src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () =>
        resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = reject;
      img.src = base64Src;
    });
  };

  const cashPaid = (data.cashamount || 0) - (data.cashchange || 0);

  const cardPaid = (data.cardamount || 0) - (data.cardchange || 0);

  const onlinePaid = (data.onlineamount || 0) - (data.onlinechange || 0);

  const upiPaid = (data.upiamount || 0) - (data.upichange || 0);

  const balanceDue = (data.paylateramount || 0) - (data.paylaterchange || 0);

  const convertToGrayScale = (dataUrl) =>
    new Promise((resolve) => {
      const img = new Image();
      img.src = dataUrl;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = img.width;
        canvas.height = img.height;

        ctx.drawImage(img, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        for (let i = 0; i < data.length; i += 4) {
          const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
          data[i] = avg;
          data[i + 1] = avg;
          data[i + 2] = avg;
        }

        ctx.putImageData(imageData, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
    });

  const isIGST =
    globalData.salefrom?.statecode &&
    globalData.saleto?.statecode &&
    globalData.salefrom.statecode !== globalData.saleto.statecode;

  const taxRows = globalData.saleitems?.reduce((acc, product) => {
    const taxPercentage = product?.taxpercentage || 0;
    const taxAmount = product?.lineTotalTaxAmount || 0;
    const basePrice = product?.lineTotalBasePrice || 0;
    if (!acc[taxPercentage]) {
      acc[taxPercentage] = { basePrice: 0, sgst: 0, cgst: 0, igst: 0 };
    }
    acc[taxPercentage].basePrice += basePrice;
    if (isIGST) {
      acc[taxPercentage].igst += taxAmount;
    } else {
      acc[taxPercentage].sgst += taxAmount / 2;
      acc[taxPercentage].cgst += taxAmount / 2;
    }
    return acc;
  }, {});

  const generate3InchinvoiceReceiptM2 = async () => {
    // Conversion constant: 1mm = 2.83465pt
    const mm = (pt) => pt / 2.83465;
    const taxRows1 = globalData.saleitems;
    const itemHeight = globalData.saleitems.length * mm(45); // Approx 45pt per item row
    const taxHeight = Object.keys(taxRows1).length * mm(25); //25
    const footerHeight = mm(250); // Total for branding, thank you, and payment boxes
    const headerHeight = mm(250); // Total for logo, store info, and invoice details

    // Total dynamic height with a small buffer
    const dynamicHeight = headerHeight + itemHeight + taxHeight + footerHeight;

    const doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: [74, dynamicHeight + mm(30)],
    });

    const pageWidth = doc.internal.pageSize.getWidth();

    let y = mm(18);

    const isIGST =
      globalData.salefrom?.statecode &&
      globalData.saleto?.statecode &&
      globalData.salefrom.statecode !== globalData.saleto.statecode;

    const taxRows = globalData.saleitems?.reduce((acc, product) => {
      const taxPercentage = product.taxpercentage || 0;
      const taxAmount = product.lineTotalTaxAmount || 0;
      const basePrice = product.lineTotalBasePrice || 0;
      if (!acc[taxPercentage]) {
        acc[taxPercentage] = { basePrice: 0, sgst: 0, cgst: 0, igst: 0 };
      }
      acc[taxPercentage].basePrice += basePrice;
      if (isIGST) {
        acc[taxPercentage].igst += taxAmount;
      } else {
        acc[taxPercentage].sgst += taxAmount / 2;
        acc[taxPercentage].cgst += taxAmount / 2;
      }
      return acc;
    }, {});
    const checkPageBreak = (doc, y, buffer = mm(20)) => {
      const pageHeight = doc.internal.pageSize.getHeight();
      if (y + buffer >= pageHeight) {
        doc.addPage();
        return mm(14);
      }
      return y;
    };
    // const storeBoxStartY = y;

    // const imagePath = uRLs?.IMAGE_URL + "profile/" + data?.salefrom?.image;

    const imagePath = settings?.saleProfileData?.image
      ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
      : "/assets/images/logo-light.png";

    if (imagePath) {
      try {
        // Step 1: Convert image URL to base64
        const response = await fetch(imagePath, { mode: "cors" });
        const blob = await response.blob();
        let base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Step 2: Convert to grayscale
        base64 = await convertToGrayScale(base64);

        // Step 3: Get natural dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Step 4: Resize to fit dynamically within maxWidth and maxHeight
        const maxWidth = mm(65); // maximum width in pt for 3-inch receipt
        const maxHeight = mm(40); // maximum height in pt
        const widthRatio = maxWidth / naturalWidth;
        const heightRatio = maxHeight / naturalHeight;
        const ratio = Math.min(widthRatio, heightRatio, 1); // don't upscale

        const imgWidth = naturalWidth * ratio;
        const imgHeight = naturalHeight * ratio;

        // Step 5: Center the logo
        const logoX = (pageWidth - imgWidth) / 2;

        doc.addImage(base64, "PNG", logoX, y, imgWidth, imgHeight);

        y += imgHeight + mm(10); // spacing after logo
      } catch (err) {
        console.warn("Logo failed to load:", err);
      }
    }

    let margin = mm(15);
    const drawDashedLine = (yPos) => {
      doc.setLineDash([mm(3), mm(3)], 0);
      doc.line(margin, yPos, pageWidth - margin, yPos);
      doc.setLineDash([]); // Reset to solid
    };
    // Header

    doc.setFont("NotoSansMono-Bold", "bold");

    doc.setFontSize(11);
    const storeTitle = settings?.saleProfileData?.title || "Store";
    doc.splitTextToSize(storeTitle, pageWidth - mm(30)).forEach((line) => {
      doc.text(line, pageWidth / 2, y, { align: "center" });
      y += mm(13);
    });
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(8);
    const seller = settings?.saleProfileData;
    const sellerAddressParts = [
      seller?.addressline1,
      [seller?.state].filter(Boolean).join(", "),
    ].filter(Boolean);
    doc
      .splitTextToSize(sellerAddressParts.join(", "), pageWidth - mm(50))
      .forEach((line) => {
        doc.text(line, pageWidth / 2, y, { align: "center" });
        y += mm(8);
      });

    // if (seller?.email) {
    //   doc.text(`Email: ${seller.email}`, pageWidth / 2, y, { align: "center" });
    //   y += 16;
    // }
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(8); // Slightly smaller to match UI

    const addressText = `${seller?.district} ${seller?.country} - ${seller?.pincode}`;
    doc.text(addressText, pageWidth / 2, y, { align: "center" });
    y += mm(9);
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(8);
    const gstText = `GST: ${seller?.gstnumber || ""}`;
    const phoneText = `Ph: ${settings?.saleProfileData?.phone || ""}`;
    const fssainumber = `FSSAI : ${seller.fssai || ""}`;
    const pannumber = `PAN : ${seller.pannumber || ""}`;
    const cinnumber = `CIN : ${seller.cinnumber || ""}`;

    const horizontalPadding = mm(12);
    const leftStart = horizontalPadding;
    const rightEnd = pageWidth - horizontalPadding;
    // Draw GST: Aligned to the far left margin
    doc.text(gstText, leftStart, y, { align: "left" });

    // Draw Phone: Aligned to the far right margin
    doc.text(phoneText, rightEnd, y, { align: "right" });
    y += mm(9);
    doc.text(fssainumber, leftStart, y, { align: "left" });

    // Draw Phone: Aligned to the far right margin
    doc.text(pannumber, rightEnd, y, { align: "right" });
    y += mm(9);
    doc.text(cinnumber, leftStart, y, { align: "left" });
    y += mm(12);
    // drawDashedLine(y);
    const storeBoxPadding = 4;

    doc.setLineWidth(mm(1));
    doc.setLineDash([mm(1), mm(1)]); // solid border

    // y += mm(8);
    const invoiceTitle =
      globalData.status === "CANCELLED"
        ? "CANCELLED TAX INVOICE"
        : "TAX INVOICE";

    doc.setFont("NotoSansMono-Bold", "bold").setFontSize(11);
    const textWidth = doc.getTextWidth(invoiceTitle);
    const gap = mm(8); // Space between the line and the text
    margin = mm(10);
    // 5. Draw the Lines
    let centerX = pageWidth / 2;
    doc.text(invoiceTitle, centerX, y, { align: "center" });
    doc.setLineWidth(mm(1));
    doc.setLineDash([mm(3), mm(3)]); // Use [0] for a solid line, [2, 2] for dashed like your image

    // Left Line: starts at margin, ends just before the text
    doc.line(margin, y - mm(4), centerX - textWidth / 2 - gap, y - mm(4));

    // Right Line: starts just after the text, ends at margin
    doc.line(
      centerX + textWidth / 2 + gap,
      y - mm(4),
      pageWidth - margin,
      y - mm(4)
    );
    // 6. Reset Dash and move Y
    doc.setLineDash([]);
    y += mm(10);

    const { date, time } = saleTime;
    const lineHeight = mm(9); // Adjusted for tighter spacing seen in UI
    const leftColX = mm(8); // Left margin
    const rightColX = pageWidth / 2 + mm(10); // Start of the second column
    const drawField = (label, value, xPos, yPos) => {
      doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9);
      const fieldText = `${label} : ${value}`;
      doc.text(fieldText, xPos, yPos);
    };
    drawField("Invoice No", `${globalData.saleno}`, leftColX, y);
    // drawField("Counter", "02", rightColX, y); // Replace "02" with your dynamic counter data
    y += lineHeight;

    // Row 2: Date
    drawField("Date", `${date}, ${time}`, leftColX, y);
    y += lineHeight;

    // Row 3: Cashier
    // drawField("Cashier", "Stejo", leftColX, y); // Replace "Stejo" with your dynamic cashier data

    const labelX = 8; // Left-aligned label start
    const colonX = 110; // Colon aligned at this point
    const valueX = 120; // Value starts after colon

    y += mm(6);

    const buyer = globalData.saleto;
    const hasBuyerInfo =
      buyer &&
      (buyer?.name ||
        buyer?.phone ||
        buyer?.addressline1 ||
        buyer?.email ||
        buyer?.gstnumber ||
        buyer?.pannumber ||
        buyer?.cinnumber);

    // --- BUYER INFORMATION SECTION ---
    if (hasBuyerInfo) {
      // 1. Section Header: Clean and Centered
      doc.setFont("NotoSansMono-Regular", "normal").setFontSize(8);
      doc.text("BUYER INFORMATION", pageWidth / 2, y, { align: "center" });
      y += mm(10);

      const leftMargin = mm(8);
      const lineHeight = mm(9);

      //   // 2. Buyer Name: Bold and Uppercase for Impact
      if (buyer.name) {
        doc.setFont("NotoSansMono-Bold", "bold").setFontSize(8);
        doc.text(buyer.name.toUpperCase(), leftMargin, y);
        y += lineHeight;
      }

      // 3. Buyer Details: Smaller and Regular font
      doc.setFont("NotoSansMono-Regular", "normal").setFontSize(8);

      // Contact Row (Phone & Email)
      if (buyer.phone || buyer.email) {
        const contactLine = [
          buyer.phone ? `Ph: ${buyer.phone}` : null,
          buyer.email ? `Email: ${buyer.email}` : null,
        ]
          .filter(Boolean)
          .join(" | ");

        doc.text(contactLine, leftMargin, y);
        y += lineHeight;
      }

      // Address: Handling long text with splitTextToSize
      const addressParts = [
        buyer.addressline1,
        [buyer.state, buyer.district, buyer.country].filter(Boolean).join(", "),
        buyer.pincode ? `- ${buyer.pincode}` : null,
      ]
        .filter(Boolean)
        .join(", ");

      if (addressParts) {
        const splitAddress = doc.splitTextToSize(
          addressParts,
          pageWidth - mm(20)
        );
        splitAddress.forEach((line) => {
          doc.text(line, leftMargin, y);
          y += lineHeight;
        });
      }

      // 4. Statutory IDs (GST, PAN, CIN): Compact layout
      const idList = [
        { label: "GST: ", value: buyer.gstnumber },
        { label: "PAN: ", value: buyer.pannumber },
        { label: "CIN: ", value: buyer.cinnumber },
      ];
      idList.forEach((item) => {
        if (item.value) {
          const leftMargin = mm(8);

          // 1. Draw the Label in BOLD
          doc.setFont("NotoSansMono-Bold", "bold").setFontSize(8);
          doc.text(item.label, leftMargin, y);

          // 2. Calculate label width so the value starts exactly after it
          const labelWidth = doc.getTextWidth(item.label);

          // 3. Draw the Value in REGULAR
          doc.setFont("NotoSansMono-Regular", "normal");
          doc.text(`${item.value}`, leftMargin + labelWidth, y);

          // 4. Move to next line
          y += mm(9);
        }
      });

      y += mm(3); // Extra spacing before the items table starts
    }

    // const itemBoxStartY = y - 10;

    // const itemRows = [
    //   [
    //     {
    //       content: "",
    //       colSpan: 4,
    //       styles: {
    //         fontSize: 14,
    //         cellPadding: 2,
    //         lineWidth: 0,
    //         halign: "center",
    //       },
    //     },
    //   ],
    //   ...data.saleitems.flatMap((item) => {
    //     const rows = [];

    //     // Title + Note in single line
    //     let titleWithNote = item.title;
    //     if (item.imode === "PRODUCT" && item.note) {
    //       titleWithNote += ` (${item.note})`;
    //     }

    //     rows.push([
    //       {
    //         content: titleWithNote,
    //         colSpan: 4,
    //       },
    //     ]);

    //     // Price row
    //     rows.push([
    //       "",
    //       `₹${CurrencyConverter.toCurrency(item.soldprice || 0, "INR")}`,
    //       `${item.quantity}`,
    //       `₹${CurrencyConverter.toCurrency(
    //         item.lineTotalSoldPrice || 0,
    //         "INR"
    //       )}`,
    //     ]);

    //     return rows;
    //   }),
    // ];
    // autoTable(doc, {
    //   startY: y,
    //   head: [
    //     [
    //       {
    //         content: "Item",
    //         colSpan: 4,
    //         styles: { halign: "left", fontStyle: "bold", font: "NotoSansMono-Bold" },
    //       },
    //     ],
    //     [
    //       { content: "", styles: { cellPadding: 0 } },
    //       {
    //         content: "Rate",
    //         styles: { halign: "center", fontStyle: "bold", font: "NotoSansMono-Bold" },
    //       },
    //       {
    //         content: "Qty",
    //         styles: { halign: "center", fontStyle: "bold", font: "NotoSansMono-Bold" },
    //       },
    //       {
    //         content: "Total",
    //         styles: { halign: "right", fontStyle: "bold", font: "NotoSansMono-Bold" },
    //       },
    //     ],
    //   ],
    //   body: itemRows,
    //   theme: "plain",
    //   styles: {
    //     fontSize: 14,
    //     cellPadding: 3,
    //     lineWidth: 0,
    //     font: "NotoSansMono-Regular",
    //   },
    //   columnStyles: {
    //     0: { halign: "left" },
    //     1: { halign: "center" },
    //     2: { halign: "center" },
    //     3: { halign: "right" },
    //   },
    //   margin: { left: 8, right: 8 },
    //   didDrawCell: (data) => {
    //     const pageWidth = doc.internal.pageSize.getWidth();
    //     const left = 8;
    //     const right = pageWidth - 8;

    //     if (
    //       data.row.section === "head" &&
    //       data.row.index === 1 &&
    //       data.column.index === 3
    //     ) {
    //       const bottom = data.cell.y + data.cell.height + 2;
    //       doc.setLineDash([1, 1], 0);
    //       doc.setDrawColor(0);
    //       doc.line(left, bottom, right, bottom);
    //       doc.setLineDash([]);
    //     }
    //     if (
    //       data.row.section === "body" &&
    //       data.row.index === itemRows.length - 1 &&
    //       data.column.index === 0
    //     ) {
    //       const bottom = data.cell.y + data.cell.height + 2;
    //       doc.setLineDash([1, 1], 0);
    //       doc.setDrawColor(0);
    //       doc.line(left, bottom, right, bottom);
    //       doc.setLineDash([]);
    //     }
    //   },
    // });

    // y = doc.lastAutoTable.finalY + 18;
    // y = checkPageBreak(doc, y);

    // Define table boundaries
    const tableMargin = mm(8);
    const tableWidth = pageWidth - tableMargin * 2;

    autoTable(doc, {
      startY: y,
      margin: { left: tableMargin, right: tableMargin },
      theme: "plain",
      // 1. Set global border styles
      styles: {
        fontSize: 8,
        cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
        lineColor: "black", // Light gray border
        lineWidth: 1,
        font: "NotoSansMono-Regular",
      },
      head: [
        // Header Row 1: "Items" label span
        [
          {
            content: "Items",
            cellPadding: 1,
            colSpan: 3,
            styles: {
              halign: "left",
              fontStyle: "bold",
              lineWidth: { left: mm(1), right: mm(1), top: mm(1), bottom: 0 },
            },
          },
        ],
        // Header Row 2: Rate, Qty, Total
        [
          {
            content: "Rate",
            cellPadding: 1,
            styles: {
              halign: "center",
              fontStyle: "bold",
              lineWidth: { left: mm(1), top: 0, bottom: mm(1) },
            },
          },
          {
            content: "Qty",
            cellPadding: 1,
            styles: {
              halign: "center",
              fontStyle: "bold",
              lineWidth: { top: 0, bottom: mm(1) },
            },
          },
          {
            content: "Total",
            cellPadding: 1,
            styles: {
              halign: "center",
              fontStyle: "bold",
              lineWidth: { right: mm(1), top: 0, bottom: mm(1) },
            },
          },
        ],
      ],
      body: globalData.saleitems.flatMap((item) => [
        // Line 1: Item Name (Full width)
        [
          {
            content: item.title + (item.note ? ` (${item.note})` : ""),
            colSpan: 3,
            styles: {
              halign: "left",
              lineWidth: { left: mm(1), right: mm(1), top: 0, bottom: 0 },
            },
          },
        ],
        // Line 2: Values (Rate, Qty, Total)
        [
          {
            content: `₹${item.soldprice}`,
            styles: {
              halign: "center",
              lineWidth: { left: mm(1), top: 0, bottom: 0 },
            },
          },
          {
            content: `${item.quantity} ${(() => {
              const unitCode = item?.isSecondaryUnit
                ? item?.unitConfig?.secondaryUnitCode
                : item?.unitConfig?.primaryUnitCode;
              return unitCode || "";
            })()}`,
            styles: { halign: "center", lineWidth: { top: 0, bottom: 0 } },
          },
          {
            content: `₹${item.lineTotalSoldPrice}`,
            styles: {
              halign: "center",
              lineWidth: { right: mm(1), top: 0, bottom: 0 },
            },
          },
        ],
      ]),
      // 3. Close the bottom border on the last row
      didDrawCell: (data) => {
        if (data.row.index === data.table.body.length - 1) {
          doc.setDrawColor(0);
          doc.setLineWidth(mm(1));
          doc.line(
            data.cell.x,
            data.cell.y + data.cell.height,
            data.cell.x + data.cell.width,
            data.cell.y + data.cell.height
          );
        }
      },
    });

    y = doc.lastAutoTable.finalY + mm(10);

    // Set dimensions for the boxes
    const boxPadding = 8;
    let boxWidth = (pageWidth - mm(24)) / 2; // Split page width minus margins
    const boxHeight = mm(35); // Height to accommodate two lines of text
    const startX = mm(8);
    const rightBoxX = startX + boxWidth + mm(8);

    // --- 1. Draw Left Box (Qty & Items) ---
    doc.setDrawColor(0); // Changed from 200 to 150 for a darker, printable gray
    doc.setLineWidth(mm(1)); // Light gray border
    doc.roundedRect(startX, y, boxWidth, boxHeight, mm(3), mm(3), "S");

    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9);
    // Qty Line
    // doc.text("Qty :", startX + mm(5), y + mm(18));
    // doc.text(`${data.totalqty || 0}`, startX + boxWidth - mm(5), y + mm(18), { align: "right" });
    // Items Line
    doc.text("Items :", startX + mm(5), y + mm(20));
    doc.text(
      `${globalData.totalItems}`,
      startX + boxWidth - mm(5),
      y + mm(20),
      {
        align: "right",
      }
    );

    // --- 2. Draw Right Box (Total Amount) ---
    doc.roundedRect(rightBoxX, y, boxWidth, boxHeight, mm(3), mm(3), "S");

    doc.setFont("NotoSansMono-Bold", "bold").setFontSize(9);
    const totalLabel = "Grand Total";
    const totalValue = `₹${globalData.grandtotal}`; // Assuming raw number as per UI
    const boxCenterX = rightBoxX + boxWidth / 2;

    // Draw Label: Centered horizontally
    doc.text(totalLabel, boxCenterX, y + mm(15), { align: "center" });

    doc.setFontSize(10);
    doc.text(totalValue, boxCenterX, y + mm(25), { align: "center" });

    // // Center the content within the right box
    // const combinedText = `${totalLabel} ${totalValue}`;
    // const textWidth1 = doc.getTextWidth(combinedText);
    // const textStartX = rightBoxX + (boxWidth - textWidth1) / 2;

    // doc.text(totalLabel, textStartX, y + 26);
    // doc.text(totalValue, textStartX + doc.getTextWidth(totalLabel) + 4, y + 26);

    y += boxHeight + mm(10); // Advance Y position for next section
    // y = checkPageBreak(doc, y);
    const boxMargin = mm(8);
    // 1. Prepare payment list (Only show modes with value)
    const payments = [
      {
        label: "Cash",
        amount: globalData.cashPaid,
      },
      {
        label: "Card",
        amount: globalData.cardPaid,
      },
      {
        label: "Online Pay",
        amount: globalData.onlinePaid,
      },
      { label: "UPI", amount: globalData.upiPaid },
      { label: "Balance Due", amount: globalData.balanceDue },
    ].filter((p) => p.amount > 0);

    autoTable(doc, {
      startY: y,
      theme: "plain",
      margin: { left: boxMargin, right: boxMargin },
      styles: {
        font: "NotoSansMono-Regular",
        fontSize: 8,
        cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
        lineColor: "black",
        lineWidth: mm(1),
      },
      head: [
        [
          {
            content: "PAYMENT MODE",
            colSpan: 3,
            styles: {
              font: "NotoSansMono-Regular",
              fontSize: 8,
              cellPadding: 1,
              fontStyle: "normal",
              lineWidth: {
                top: mm(1),
                left: mm(1),
                right: mm(1),
                bottom: mm(1),
              },
            },
          },
        ],
      ],
      body: [
        ...payments.map((p) => [
          {
            content: p.label,
            styles: { fontSize: 7, lineWidth: { left: mm(1) } },
          },
          { content: ":", styles: { halign: "center", lineWidth: 0 } },
          {
            content: `₹${p.amount}`,
            styles: {
              halign: "right",
              lineWidth: { right: mm(1) },
              fontSize: 8,
            },
          },
        ]),
        // Bottom Right Footer for Tender and Balance
        [
          {
            // content: `Tender: ₹${CurrencyConverter.toCurrency(data.cashamount || 0||0, "INR")}\nBalance: ₹${CurrencyConverter.toCurrency(data.cashchange || 0||0, "INR")}`,
            content: `Grand Total:   ₹${globalData.grandtotal}`,
            colSpan: 5,
            styles: {
              halign: "right",
              font: "NotoSansMono-Bold",
              fontStyle: "bold",
              fontSize: 9,
              cellPadding: 2,
              lineWidth: {
                left: mm(1),
                right: mm(1),
                bottom: mm(1),
                top: mm(1),
              },
            },
          },
        ],
      ],
      columnStyles: {
        0: { cellWidth: "auto" },
        1: { cellWidth: "20" },
        2: { cellWidth: "auto" },
      },
    });

    y = doc.lastAutoTable.finalY + mm(15);

    const itemBoxPadding = 4;
    // y = checkPageBreak(doc, y)

    doc.setDrawColor(0);
    doc.setLineWidth(mm(1));
    const taxHead = isIGST
      ? [["Tax", "Amount", "IGST"]]
      : [["Tax", "Amount", "SGST", "CGST"]];

    const taxBody = Object.entries(taxRows)
      .filter(([percent]) => parseFloat(percent) > 0)
      .map(([percent, t]) =>
        isIGST
          ? [`${percent}%`, `₹${t.basePrice}`, `₹${t.igst}`]
          : [`${percent}%`, `₹${t.basePrice}`, `₹${t.sgst}`, `₹${t.cgst}`]
      );
    // 1. Define margins and capture the starting Y position
    const taxBoxMargin = mm(8);
    const taxInternalPadding = mm(5);
    const taxBoxWidth = pageWidth - taxBoxMargin * 2;
    const taxStartPointY = y; // Save where the box starts

    if (taxBody.length > 0) {
      // 2. Generate the table FIRST
      autoTable(doc, {
        startY: taxStartPointY + taxInternalPadding,
        head: [
          taxHead[0].map((cell, colIndex) => ({
            content: cell,
            styles: {
              font: "NotoSansMono-Bold",
              fontSize: 9,
              fontStyle: "bold",
              cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
              halign: colIndex === 0 ? "left" : "right",
            },
          })),
        ],
        body: taxBody.map((row) =>
          row.map((cell, colIndex) => ({
            content: cell,
            styles: {
              font: "NotoSansMono-Regular",
              fontStyle: "normal",
              fontSize: 8,
              cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
              halign: colIndex === 0 ? "left" : "right",
            },
          }))
        ),
        theme: "plain",
        styles: {
          font: "NotoSansMono-Regular",
          fontStyle: "normal",
          fontSize: 8,
          // cellPadding: 2,
          lineWidth: 0,
        },
        margin: {
          left: taxBoxMargin + taxInternalPadding,
          right: taxBoxMargin + taxInternalPadding,
        },
      });

      // 3. CALCULATE HEIGHT: Use the final Y of the table
      const taxEndPointY = doc.lastAutoTable.finalY + taxInternalPadding;
      const dynamicBoxHeight = taxEndPointY - taxStartPointY;

      // 4. DRAW THE BOX: Now we know the exact height needed
      doc.setDrawColor(0);
      doc.setLineWidth(mm(1));
      doc.rect(
        taxBoxMargin,
        taxStartPointY,
        taxBoxWidth,
        dynamicBoxHeight,
        "S"
      );

      // 5. Update global Y for the next section
      y = taxEndPointY + mm(10);
    }

    //   const itemBoxPadding = 4;
    //     y = checkPageBreak(doc, y)
    //     const boxMargin = 8;

    //  const taxHead = isIGST
    //     ? [["Tax", "Amount", "IGST"]]
    //     : [["Tax", "Amount", "SGST", "CGST"]];

    //   const taxBody = Object.entries(taxRows)
    //     .filter(([percent]) => parseFloat(percent) > 0)
    //     .map(([percent, t]) =>
    //       isIGST
    //         ? [
    //             `${percent}%`,
    //             `₹${CurrencyConverter.toCurrency(t.basePrice || 0, "INR")}`,
    //             `₹${CurrencyConverter.toCurrency(t.igst || 0, "INR")}`,
    //           ]
    //         : [
    //             `${percent}%`,
    //             `₹${CurrencyConverter.toCurrency(t.basePrice || 0, "INR")}`,
    //             `₹${CurrencyConverter.toCurrency(t.sgst || 0, "INR")}`,
    //             `₹${CurrencyConverter.toCurrency(t.cgst || 0, "INR")}`,
    //           ]
    //     );
    //    y = checkPageBreak(doc, y)
    //         let tableRendered = false;
    //   if (taxBody.length > 0) {
    //     tableRendered = true;

    //     autoTable(doc, {
    //       startY: y,
    //       head: taxHead.map((row) =>
    //         row.map((cell, colIndex) => ({
    //           content: cell,
    //           styles: {
    //           font: "NotoSansMono-Bold",
    //                   fontSize: 14,
    //                   fontStyle: "bold",
    //               cellPadding: 2,
    //             halign: colIndex === 0 ? "left" : "right",
    //           },
    //         })),
    //       ),
    //       body: taxBody.map((row) =>
    //         row.map((cell, colIndex) => ({
    //           content: cell,
    //           styles: {
    //             font: "NotoSansMono-Regular",
    //             fontStyle: "normal",
    //              fontSize: 13,
    //             halign: colIndex === 0 ? "left" : "right",
    //           },
    //         })),
    //       ),
    //       theme: "plain",
    //       styles: {
    //         font: "NotoSansMono-Regular",
    //         fontStyle: "normal",
    //           fontSize: 12,
    //         cellPadding: 5,
    //         lineWidth: 0,
    //       },
    //       margin: { left: 10, right: 10 },
    //       columnStyles: {
    //         0: { halign: "left" },
    //         1: { halign: "right" },
    //         2: { halign: "right" },
    //         3: { halign: "right" },
    //       },
    //       didDrawCell: (data) => {
    //         const pageWidth = doc.internal.pageSize.getWidth();

    //         if (
    //           data.row.section === "head" &&
    //           data.row.index === 0 &&
    //           data.column.index === 0
    //         ) {
    //           const top = data.cell.y - 2;
    //           doc.setLineDash([1, 1], 0);
    //           doc.setDrawColor(150);
    //           doc.line(0, top, pageWidth - 5, top);
    //         }

    //         const isLastTaxRow =
    //           data.row.section === "body" &&
    //           data.row.index === taxBody.length - 1;

    //         if (isLastTaxRow && data.column.index === 0) {
    //           const bottom = data.cell.y + data.cell.height + 2;
    //           doc.setLineDash([1, 1], 0);
    //           doc.setDrawColor(150);
    //           doc.line(0, bottom, pageWidth - 5, bottom);
    //           doc.setLineDash([]);
    //         }
    //       },
    //     });
    //   }
    // if (tableRendered && doc.lastAutoTable?.finalY) {
    //     y = doc.lastAutoTable.finalY + 10;
    //   }
    // y = checkPageBreak(doc, y);
    if (globalData.totaldiscount > 0) {
      const boxMargin = mm(8);
      const boxHeight = mm(20);
      const boxWidth = pageWidth - boxMargin * 2;
      // o 1
      // 1. Draw the Container Box
      doc.setDrawColor(0); // Light Gray border
      doc.setLineWidth(mm(1));
      doc.rect(boxMargin, y, boxWidth, boxHeight, "S");

      // 2. Set Font for the content
      doc.setFont("NotoSansMono-Regular", "normal").setFontSize(8);

      const savedAmount = `₹${globalData.totaldiscount}`;
      doc.text(`YOU SAVED :  ${savedAmount}`, boxMargin + mm(4), y + mm(14));

      // doc.text(savedAmount, pageWidth - (boxMargin + 4), y + 14, { align: "right" });

      y += boxHeight + mm(10);
    }
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(11);

    // y += mm(10);
    doc.setFontSize(8);
    doc.text("Thank you for your purchase!", pageWidth / 2, y, {
      align: "center",
    });
    y += mm(10);
    //   doc.setFont("NotoSansMono-Bold", "bold");
    //   doc.text("** Visit us Again **", pageWidth / 2, y, { align: "center" });
    //   const thankBoxPadding=10;
    //  y += mm(18);

    doc.setFont("NotoSansMono-Regular", "normal");
    doc.text("Powered By", pageWidth / 2, y, { align: "center" });
    y += mm(10);
    doc.setFontSize(8);
    const sitePrefix = "www.";
    const siteBold = "NegoBill";
    const siteSuffix = ".com";
    const prefixWidth = doc.getTextWidth(sitePrefix);
    const boldWidth = doc.getTextWidth(siteBold);
    const suffixWidth = doc.getTextWidth(siteSuffix);
    const totalWidth = prefixWidth + boldWidth + suffixWidth;
    const startX1 = (pageWidth - totalWidth) / 2;
    if (storeSettings?.negobillBranding) {
      doc.setFont("NotoSansMono-Regular", "normal");
      doc.text(sitePrefix, startX1, y);
      doc.setFont("NotoSansMono-Bold", "bold");
      doc.text(siteBold, startX1 + prefixWidth, y);
      doc.setFont("NotoSansMono-Regular", "normal");
      doc.text(siteSuffix, startX1 + prefixWidth + boldWidth, y);
      y += mm(3);
    }
    setPrint(false);
    setDownload(false);
    return doc;
  };

  const generate4InchinvoiceReceipt = async () => {
    const doc = new jsPDF({
      unit: "pt",
      format: [288, 1000],
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    let y = 10;

    const isIGST =
      data.salefrom?.statecode &&
      data.saleto?.statecode &&
      data.salefrom.statecode !== data.saleto.statecode;

    const taxRows = data.saleitems?.reduce((acc, product) => {
      const taxPercentage = product.taxpercentage || 0;
      const taxAmount = product.lineTotalTaxAmount || 0;
      const basePrice = product.lineTotalBasePrice || 0;
      if (!acc[taxPercentage]) {
        acc[taxPercentage] = { basePrice: 0, sgst: 0, cgst: 0, igst: 0 };
      }
      acc[taxPercentage].basePrice += basePrice;
      if (isIGST) {
        acc[taxPercentage].igst += taxAmount;
      } else {
        acc[taxPercentage].sgst += taxAmount / 2;
        acc[taxPercentage].cgst += taxAmount / 2;
      }
      return acc;
    }, {});
    const checkPageBreak = (doc, y, buffer = 20) => {
      const pageHeight = doc.internal.pageSize.getHeight();
      if (y + buffer >= pageHeight) {
        doc.addPage();
        return 14;
      }
      return y;
    };
    // const storeBoxStartY = y;

    // const imagePath = uRLs?.IMAGE_URL + "profile/" + data?.salefrom?.image;

    const imagePath = settings?.saleProfileData?.image
      ? uRLs?.IMAGE_URL + "profile/" + settings?.saleProfileData?.image
      : "/assets/images/logo-light.png";

    if (imagePath) {
      try {
        // Step 1: Convert image URL to base64
        const response = await fetch(imagePath, { mode: "cors" });
        const blob = await response.blob();
        let base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Step 2: Convert to grayscale
        base64 = await convertToGrayScale(base64);

        // Step 3: Get natural dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Step 4: Resize to fit dynamically within maxWidth and maxHeight
        const maxWidth = 80; // maximum width in pt for 3-inch receipt
        const maxHeight = 40; // maximum height in pt
        const widthRatio = maxWidth / naturalWidth;
        const heightRatio = maxHeight / naturalHeight;
        const ratio = Math.min(widthRatio, heightRatio, 1); // don't upscale

        const imgWidth = naturalWidth * ratio;
        const imgHeight = naturalHeight * ratio;

        // Step 5: Center the logo
        const logoX = (pageWidth - imgWidth) / 2;

        doc.addImage(base64, "PNG", logoX, y, imgWidth, imgHeight);

        y += imgHeight + 20; // spacing after logo
      } catch (err) {
        console.warn("Logo failed to load:", err);
      }
    }

    let margin = 15;
    const drawDashedLine = (yPos) => {
      doc.setLineDash([3, 3], 0);
      doc.line(margin, yPos, pageWidth - margin, yPos);
      doc.setLineDash([]); // Reset to solid
    };
    // Header

    doc.setFont("Inter-Bold", "bold");

    doc.setFontSize(14);
    const storeTitle = data.salefrom?.title || "Store";
    doc.splitTextToSize(storeTitle, pageWidth - 30).forEach((line) => {
      doc.text(line, pageWidth / 2, y, { align: "center" });
      y += 16;
    });
    doc.setFont("Inter-Regular", "normal").setFontSize(12);
    const seller = data.salefrom;
    const sellerAddressParts = [
      seller?.addressline1,
      [seller?.state].filter(Boolean).join(", "),
    ].filter(Boolean);
    doc
      .splitTextToSize(sellerAddressParts.join(", "), pageWidth - 50)
      .forEach((line) => {
        doc.text(line, pageWidth / 2, y, { align: "center" });
        y += 16;
      });

    // if (seller?.email) {
    //   doc.text(`Email: ${seller.email}`, pageWidth / 2, y, { align: "center" });
    //   y += 16;
    // }
    doc.setFont("Inter-Regular", "normal").setFontSize(10); // Slightly smaller to match UI

    const addressText = `${seller?.district} ${seller?.country} - ${seller?.pincode}`;
    doc.text(addressText, pageWidth / 2, y, { align: "center" });
    y += 14;
    doc.setFont("Inter-Regular", "normal").setFontSize(10);
    const gstText = `GST: ${seller?.gstnumber || ""}`;
    const phoneText = `Ph: ${data.salefrom?.phone || ""}`;

    const horizontalPadding = 12;
    const leftStart = horizontalPadding;
    const rightEnd = pageWidth - horizontalPadding;
    // Draw GST: Aligned to the far left margin
    doc.text(gstText, leftStart, y, { align: "left" });

    // Draw Phone: Aligned to the far right margin
    doc.text(phoneText, rightEnd, y, { align: "right" });
    y += 14;

    const fassiTest = `FASSI: ${seller?.fassinumber || ""}`;
    const panTex = `PAN: ${seller?.salefrom?.pannumber || ""}`;

    doc.setFont("Inter-Regular", "normal").setFontSize(10);
    // const gstText = `GST: ${seller?.gstnumber || ""}`;
    // const phoneText = `Ph: ${data.salefrom?.phone || ""}`;

    // Draw GST: Aligned to the far left margin
    doc.text(fassiTest, leftStart, y, { align: "left" });

    // Draw Phone: Aligned to the far right margin
    doc.text(panTex, rightEnd, y, { align: "right" });
    y += 10;

    // drawDashedLine(y);
    const storeBoxPadding = 4;

    doc.setLineWidth(1);
    doc.setLineDash([1, 1]); // solid border

    y += 16;
    const invoiceTitle =
      data.status === "CANCELLED" ? "CANCELLED TAX INVOICE" : "TAX INVOICE";

    doc.setFont("Inter-Bold", "bold").setFontSize(14);
    const textWidth = doc.getTextWidth(invoiceTitle);
    const gap = 8; // Space between the line and the text
    margin = 10;
    // 5. Draw the Lines
    let centerX = pageWidth / 2;
    doc.text(invoiceTitle, centerX, y, { align: "center" });
    doc.setLineWidth(1);
    doc.setLineDash([3, 3]); // Use [0] for a solid line, [2, 2] for dashed like your image

    // Left Line: starts at margin, ends just before the text
    doc.line(margin, y - 4, centerX - textWidth / 2 - gap, y - 4);

    // Right Line: starts just after the text, ends at margin
    doc.line(centerX + textWidth / 2 + gap, y - 4, pageWidth - margin, y - 4);
    console.log("data", data);
    // 6. Reset Dash and move Y
    doc.setLineDash([]);
    y += 20;

    const { date, time } = saleTime;
    const lineHeight = 14; // Adjusted for tighter spacing seen in UI
    const leftColX = 8; // Left margin
    const rightColX = pageWidth / 2 + 10; // Start of the second column
    const drawField = (label, value, xPos, yPos) => {
      doc.setFont("Inter-Regular", "normal").setFontSize(12);
      const fieldText = `${label} : ${value}`;
      doc.text(fieldText, xPos, yPos);
    };
    drawField("Invoice No", `${data.saleno}`, leftColX, y);
    // drawField("Counter", "02", rightColX, y); // Replace "02" with your dynamic counter data
    y += lineHeight + 5;

    // Row 2: Date
    drawField("Date", `${date}, ${time}`, leftColX, y);
    y += lineHeight + 5;

    // Row 3: Cashier
    // drawField("Cashier", "Stejo", leftColX, y); // Replace "Stejo" with your dynamic cashier data

    const labelX = 8; // Left-aligned label start
    const colonX = 110; // Colon aligned at this point
    const valueX = 120; // Value starts after colon

    y += 12;

    const buyer = data.saleto;
    const hasBuyerInfo =
      buyer &&
      (buyer?.name ||
        buyer?.phone ||
        buyer?.addressline1 ||
        buyer?.email ||
        buyer?.gstnumber ||
        buyer?.pannumber ||
        buyer?.cinnumber);

    // --- BUYER INFORMATION SECTION ---
    if (hasBuyerInfo) {
      // 1. Section Header: Clean and Centered
      doc.setFont("Inter-Regular", "normal").setFontSize(11);
      doc.text("BUYER INFORMATION", pageWidth / 2, y, { align: "center" });
      y += 18;

      const leftMargin = 10;
      const lineHeight = 16;

      // 2. Buyer Name: Bold and Uppercase for Impact
      if (buyer.name) {
        doc.setFont("Inter-Bold", "bold").setFontSize(10);
        doc.text(buyer.name.toUpperCase(), leftMargin, y);
        y += lineHeight;
      }

      // 3. Buyer Details: Smaller and Regular font
      doc.setFont("Inter-Regular", "normal").setFontSize(10);

      // Contact Row (Phone & Email)
      if (buyer.phone || buyer.email) {
        const contactLine = [
          buyer.phone ? `Ph: ${buyer.phone}` : null,
          buyer.email ? `Email: ${buyer.email}` : null,
        ]
          .filter(Boolean)
          .join(" | ");

        doc.text(contactLine, leftMargin, y);
        y += lineHeight;
      }

      // Address: Handling long text with splitTextToSize
      const addressParts = [
        buyer.addressline1,
        [buyer.state, buyer.district, buyer.country].filter(Boolean).join(", "),
        buyer.pincode ? `- ${buyer.pincode}` : null,
      ]
        .filter(Boolean)
        .join(", ");

      if (addressParts) {
        const splitAddress = doc.splitTextToSize(addressParts, pageWidth - 20);
        splitAddress.forEach((line) => {
          doc.text(line, leftMargin, y);
          y += lineHeight;
        });
      }

      // 4. Statutory IDs (GST, PAN, CIN): Compact layout
      const idList = [
        { label: "GST: ", value: buyer.gstnumber },
        { label: "PAN: ", value: buyer.pannumber },
        { label: "CIN: ", value: buyer.cinnumber },
      ];
      idList.forEach((item) => {
        if (item.value) {
          const leftMargin = 10;

          // 1. Draw the Label in BOLD
          doc.setFont("Inter-Bold", "bold").setFontSize(10);
          doc.text(item.label, leftMargin, y);

          // 2. Calculate label width so the value starts exactly after it
          const labelWidth = doc.getTextWidth(item.label);

          // 3. Draw the Value in REGULAR
          doc.setFont("Inter-Regular", "normal");
          doc.text(`${item.value}`, leftMargin + labelWidth, y);

          // 4. Move to next line
          y += 14;
        }
      });

      y += 10; // Extra spacing before the items table starts
    }

    // const itemBoxStartY = y - 10;

    // const itemRows = [
    //   [
    //     {
    //       content: "",
    //       colSpan: 4,
    //       styles: {
    //         fontSize: 14,
    //         cellPadding: 2,
    //         lineWidth: 0,
    //         halign: "center",
    //       },
    //     },
    //   ],
    //   ...data.saleitems.flatMap((item) => {
    //     const rows = [];

    //     // Title + Note in single line
    //     let titleWithNote = item.title;
    //     if (item.imode === "PRODUCT" && item.note) {
    //       titleWithNote += ` (${item.note})`;
    //     }

    //     rows.push([
    //       {
    //         content: titleWithNote,
    //         colSpan: 4,
    //       },
    //     ]);

    //     // Price row
    //     rows.push([
    //       "",
    //       `₹${CurrencyConverter.toCurrency(item.soldprice || 0, "INR")}`,
    //       `${item.quantity}`,
    //       `₹${CurrencyConverter.toCurrency(
    //         item.lineTotalSoldPrice || 0,
    //         "INR"
    //       )}`,
    //     ]);

    //     return rows;
    //   }),
    // ];
    // autoTable(doc, {
    //   startY: y,
    //   head: [
    //     [
    //       {
    //         content: "Item",
    //         colSpan: 4,
    //         styles: { halign: "left", fontStyle: "bold", font: "Inter-Bold" },
    //       },
    //     ],
    //     [
    //       { content: "", styles: { cellPadding: 0 } },
    //       {
    //         content: "Rate",
    //         styles: { halign: "center", fontStyle: "bold", font: "Inter-Bold" },
    //       },
    //       {
    //         content: "Qty",
    //         styles: { halign: "center", fontStyle: "bold", font: "Inter-Bold" },
    //       },
    //       {
    //         content: "Total",
    //         styles: { halign: "right", fontStyle: "bold", font: "Inter-Bold" },
    //       },
    //     ],
    //   ],
    //   body: itemRows,
    //   theme: "plain",
    //   styles: {
    //     fontSize: 14,
    //     cellPadding: 3,
    //     lineWidth: 0,
    //     font: "Inter-Regular",
    //   },
    //   columnStyles: {
    //     0: { halign: "left" },
    //     1: { halign: "center" },
    //     2: { halign: "center" },
    //     3: { halign: "right" },
    //   },
    //   margin: { left: 8, right: 8 },
    //   didDrawCell: (data) => {
    //     const pageWidth = doc.internal.pageSize.getWidth();
    //     const left = 8;
    //     const right = pageWidth - 8;

    //     if (
    //       data.row.section === "head" &&
    //       data.row.index === 1 &&
    //       data.column.index === 3
    //     ) {
    //       const bottom = data.cell.y + data.cell.height + 2;
    //       doc.setLineDash([1, 1], 0);
    //       doc.setDrawColor(0);
    //       doc.line(left, bottom, right, bottom);
    //       doc.setLineDash([]);
    //     }
    //     if (
    //       data.row.section === "body" &&
    //       data.row.index === itemRows.length - 1 &&
    //       data.column.index === 0
    //     ) {
    //       const bottom = data.cell.y + data.cell.height + 2;
    //       doc.setLineDash([1, 1], 0);
    //       doc.setDrawColor(0);
    //       doc.line(left, bottom, right, bottom);
    //       doc.setLineDash([]);
    //     }
    //   },
    // });

    // y = doc.lastAutoTable.finalY + 18;
    // y = checkPageBreak(doc, y);

    // Define table boundaries
    const tableMargin = 8;
    const tableWidth = pageWidth - tableMargin * 2;

    autoTable(doc, {
      startY: y,
      margin: { left: tableMargin, right: tableMargin },
      theme: "plain",
      // 1. Set global border styles
      styles: {
        fontSize: 13,
        cellPadding: 4,
        lineColor: "black", // Light gray border
        lineWidth: 1,
        font: "Inter-Regular",
      },
      head: [
        // Header Row 1: "Items" label span
        [
          {
            content: "Items",
            colSpan: 3,
            styles: {
              halign: "left",
              fontStyle: "bold",
              lineWidth: { left: 1, right: 1, top: 1, bottom: 0 },
            },
          },
        ],
        // Header Row 2: Rate, Qty, Total
        [
          {
            content: "Rate",
            styles: {
              halign: "center",
              fontStyle: "bold",
              lineWidth: { left: 1, top: 0, bottom: 1 },
            },
          },
          {
            content: "Qty",
            styles: {
              halign: "center",
              fontStyle: "bold",
              lineWidth: { top: 0, bottom: 1 },
            },
          },
          {
            content: "Total",
            styles: {
              halign: "center",
              fontStyle: "bold",
              lineWidth: { right: 1, top: 0, bottom: 1 },
            },
          },
        ],
      ],
      body: data.saleitems.flatMap((item) => [
        // Line 1: Item Name (Full width)
        [
          {
            content: item.title + (item.note ? ` (${item.note})` : ""),
            colSpan: 3,
            styles: {
              halign: "left",
              lineWidth: { left: 1, right: 1, top: 0, bottom: 0 },
            },
          },
        ],
        // Line 2: Values (Rate, Qty, Total)
        [
          {
            content: `₹${CurrencyConverter.toCurrency(
              item.soldprice || 0,
              "INR"
            )}`,
            styles: {
              halign: "center",
              lineWidth: { left: 1, top: 0, bottom: 0 },
            },
          },
          {
            content: `${item.quantity}`,
            styles: { halign: "center", lineWidth: { top: 0, bottom: 0 } },
          },
          {
            content: `₹${CurrencyConverter.toCurrency(
              item.lineTotalSoldPrice || 0,
              "INR"
            )}`,
            styles: {
              halign: "center",
              lineWidth: { right: 1, top: 0, bottom: 0 },
            },
          },
        ],
      ]),
      // 3. Close the bottom border on the last row
      didDrawCell: (data) => {
        if (data.row.index === data.table.body.length - 1) {
          doc.setDrawColor(0);
          doc.setLineWidth(1);
          doc.line(
            data.cell.x,
            data.cell.y + data.cell.height,
            data.cell.x + data.cell.width,
            data.cell.y + data.cell.height
          );
        }
      },
    });

    y = doc.lastAutoTable.finalY + 10;

    // Set dimensions for the boxes
    const boxPadding = 8;
    let boxWidth = (pageWidth - 24) / 2; // Split page width minus margins
    const boxHeight = 45; // Height to accommodate two lines of text
    const startX = 8;
    const rightBoxX = startX + boxWidth + 8;

    // --- 1. Draw Left Box (Qty & Items) ---
    doc.setDrawColor(0); // Changed from 200 to 150 for a darker, printable gray
    doc.setLineWidth(1); // Light gray border
    doc.roundedRect(startX, y, boxWidth, boxHeight, 3, 3, "S");

    doc.setFont("Inter-Regular", "normal").setFontSize(12);
    // Qty Line
    // doc.text("Qty :", startX + 5, y + 18);
    // doc.text(`${data.totalqty || 0}`, startX + boxWidth - 5, y + 18, { align: "right" });
    // Items Line
    doc.text("Items :", startX + 5, y + 25);
    doc.text(`${data.totalItems}`, startX + boxWidth - 5, y + 25, {
      align: "right",
    }); //old y+36

    // --- 2. Draw Right Box (Total Amount) ---
    doc.roundedRect(rightBoxX, y, boxWidth, boxHeight, 3, 3, "S");

    doc.setFont("Inter-Bold", "bold").setFontSize(12);
    const totalLabel = "Total Amount";
    const totalValue = `₹${CurrencyConverter.toCurrency(
      data.totalbaseprice || 0,
      "INR"
    )}`; // Assuming raw number as per UI
    const boxCenterX = rightBoxX + boxWidth / 2;

    // Draw Label: Centered horizontally
    doc.text(totalLabel, boxCenterX, y + 18, { align: "center" });

    doc.setFontSize(13);
    doc.text(totalValue, boxCenterX, y + 38, { align: "center" });

    // // Center the content within the right box
    // const combinedText = `${totalLabel} ${totalValue}`;
    // const textWidth1 = doc.getTextWidth(combinedText);
    // const textStartX = rightBoxX + (boxWidth - textWidth1) / 2;

    // doc.text(totalLabel, textStartX, y + 26);
    // doc.text(totalValue, textStartX + doc.getTextWidth(totalLabel) + 4, y + 26);

    y += boxHeight + 10; // Advance Y position for next section

    y = checkPageBreak(doc, y);
    const boxMarging = 8;
    console.log("y", data.cashamount);
    // 1. Prepare payment list (Only show modes with value)
    const payments = [
      {
        label: "Cash",
        amount: (data.cashamount || 0) - (data.cashchange || 0),
      },
      {
        label: "Card",
        amount: (data.cardamount || 0) - (data.cardchange || 0),
      },
      {
        label: "Online Pay",
        amount: (data.onlineamount || 0) - (data.onlinechange || 0),
      },
      { label: "UPI", amount: (data.upiamount || 0) - (data.upichange || 0) },
    ].filter((p) => p.amount > 0);

    autoTable(doc, {
      startY: y,
      theme: "plain",
      margin: { left: boxMarging, right: boxMarging },
      styles: {
        font: "Inter-Regular",
        fontSize: 10,
        cellPadding: 6,
        lineColor: "black",
        lineWidth: 1,
      },
      head: [
        [
          {
            content: "PAYMENT MODE",
            colSpan: 3,
            styles: {
              font: "Inter-Bold",
              fontSize: 12,
              cellPadding: 8,
              fontStyle: "bold",
              lineWidth: { top: 1, left: 1, right: 1, bottom: 1 },
            },
          },
        ],
      ],
      body: [
        ...payments.map((p) => [
          {
            content: p.label,
            styles: { fontSize: 12, lineWidth: { left: 0.5 } },
          },
          { content: ":", styles: { halign: "center", lineWidth: 0 } },
          {
            content: `₹${CurrencyConverter.toCurrency(p.amount || 0, "INR")}`,
            styles: { halign: "right", lineWidth: { right: 1 }, fontSize: 12 },
          },
        ]),
        // Bottom Right Footer for Tender and Balance
        [
          {
            // content: `Tender: ₹${CurrencyConverter.toCurrency(data.cashamount || 0||0, "INR")}\nBalance: ₹${CurrencyConverter.toCurrency(data.cashchange || 0||0, "INR")}`,
            content: `Grand Total:   ₹${CurrencyConverter.toCurrency(
              data.grandtotal || 0 || 0,
              "INR"
            )}`,
            colSpan: 5,
            styles: {
              halign: "right",
              font: "Inter-Bold",
              fontStyle: "bold",
              fontSize: 13,
              cellPadding: 8,
              lineWidth: { left: 1, right: 1, bottom: 1, top: 1 },
            },
          },
        ],
      ],
      columnStyles: {
        0: { cellWidth: "auto" },
        1: { cellWidth: "20" },
        2: { cellWidth: "auto" },
      },
    });

    y = doc.lastAutoTable.finalY + 15;
    // }

    // ---------- TAX TABLE SECTION (FULL) ----------

    // 1. Build Tax Head
    const taxHead = isIGST
      ? [["Tax", "Amount", "IGST"]]
      : [["Tax", "Amount", "SGST", "CGST"]];

    // 2. Build Tax Body
    const taxBody = Object.entries(taxRows)
      .filter(([percent]) => parseFloat(percent) > 0)
      .map(([percent, t]) =>
        isIGST
          ? [
              `${percent}%`,
              `₹${CurrencyConverter.toCurrency(t.basePrice || 0, "INR")}`,
              `₹${CurrencyConverter.toCurrency(t.igst || 0, "INR")}`,
            ]
          : [
              `${percent}%`,
              `₹${CurrencyConverter.toCurrency(t.basePrice || 0, "INR")}`,
              `₹${CurrencyConverter.toCurrency(t.sgst || 0, "INR")}`,
              `₹${CurrencyConverter.toCurrency(t.cgst || 0, "INR")}`,
            ]
      );

    // 3. Render Table Only If Tax Exists
    if (taxBody.length > 0) {
      const tableMargin = 8;

      autoTable(doc, {
        startY: y,
        margin: { left: tableMargin, right: tableMargin },
        theme: "plain",

        styles: {
          fontSize: 12,
          cellPadding: 4,
          lineColor: "black",
          lineWidth: 0,
          font: "Inter-Regular",
          fontStyle: "normal",
        },

        // 4. Dynamic Head
        head: taxHead.map((row) =>
          row.map((cell, colIndex) => ({
            content: cell,
            styles: {
              halign: colIndex === 0 ? "left" : "right",
              font: "Inter-Bold",
              fontStyle: "bold",
              lineWidth: {
                top: 1,
                bottom: 0,
                left: colIndex === 0 ? 1 : 0,
                right: colIndex === row.length - 1 ? 1 : 0,
              },
            },
          }))
        ),

        // 5. Dynamic Body
        body: taxBody.map((row) =>
          row.map((cell, colIndex) => ({
            content: cell,
            styles: {
              halign: colIndex === 0 ? "left" : "right",
              lineWidth: {
                left: colIndex === 0 ? 1 : 0,
                right: colIndex === row.length - 1 ? 1 : 0,
                top: 0,
                bottom: 0,
              },
            },
          }))
        ),

        // 6. Draw Bottom Border for Last Row
        didDrawCell: (data) => {
          if (
            data.row.section === "body" &&
            data.row.index === data.table.body.length - 1
          ) {
            doc.setDrawColor(0);
            doc.setLineWidth(1);
            doc.line(
              data.cell.x,
              data.cell.y + data.cell.height,
              data.cell.x + data.cell.width,
              data.cell.y + data.cell.height
            );
          }
        },
      });

      // 7. Move Y After Tax Table
      y = doc.lastAutoTable.finalY + 10;
    }
    y = checkPageBreak(doc, y);
    if (parseFloat(data.totaldiscount) > 0) {
      const boxMargin = 8;
      const boxHeight = 20;
      const boxWidth = pageWidth - boxMargin * 2;
      // o 1
      // 1. Draw the Container Box
      doc.setDrawColor(0); // Light Gray border
      doc.setLineWidth(1);
      doc.rect(boxMargin, y, boxWidth, boxHeight, "S");

      // 2. Set Font for the content
      doc.setFont("Inter-Regular", "normal").setFontSize(12);

      const savedAmount = `₹${CurrencyConverter.toCurrency(
        data.totaldiscount,
        "INR"
      )}`;
      doc.text(`YOU SAVED :  ${savedAmount}`, boxMargin + 4, y + 14);

      // doc.text(savedAmount, pageWidth - (boxMargin + 4), y + 14, { align: "right" });

      y += boxHeight + 10;
    }
    doc.setFont("Inter-Regular", "normal").setFontSize(14);

    y += 15;
    doc.setFontSize(14);
    doc.text("Thank you for your purchase!", pageWidth / 2, y, {
      align: "center",
    });
    y += 20;
    doc.setFont("Inter-Bold", "bold");
    doc.text("** Visit us Again **", pageWidth / 2, y, { align: "center" });
    const thankBoxPadding = 10;
    y += 18;

    doc.setFont("Inter-Regular", "normal");
    doc.text("Powered By", pageWidth / 2, y, { align: "center" });
    y += 18;
    doc.setFontSize(10);
    const sitePrefix = "www.";
    const siteBold = "NegoBill";
    const siteSuffix = ".com";
    const prefixWidth = doc.getTextWidth(sitePrefix);
    const boldWidth = doc.getTextWidth(siteBold);
    const suffixWidth = doc.getTextWidth(siteSuffix);
    const totalWidth = prefixWidth + boldWidth + suffixWidth;
    const startX1 = (pageWidth - totalWidth) / 2;
    if (storeSettings?.negobillBranding) {
      doc.setFont("Inter-Regular", "normal");
      doc.text(sitePrefix, startX1, y);
      doc.setFont("Inter-Bold", "bold");
      doc.text(siteBold, startX1 + prefixWidth, y);
      doc.setFont("Inter-Regular", "normal");
      doc.text(siteSuffix, startX1 + prefixWidth + boldWidth, y);
      y += 30;
    }
    // setPrint(false);
    return doc;
  };

  const generate4InchBillReceipt = async () => {
    const doc = new jsPDF({
      unit: "pt",
      format: [288, 1000],
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    let y = 18;

    const checkPageBreak = (doc, y, buffer = 20) => {
      const pageHeight = doc.internal.pageSize.getHeight();
      if (y + buffer >= pageHeight) {
        doc.addPage();
        return 14; // reset y to top margin for new page
      }
      return y;
    };

    const imagePath = uRLs?.IMAGE_URL + "profile/" + data?.salefrom?.image;

    if (data?.salefrom?.image) {
      try {
        // Step 1: Convert image URL to base64
        const response = await fetch(imagePath, { mode: "cors" });
        const blob = await response.blob();
        let base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });

        // Step 2: Convert to grayscale
        base64 = await convertToGrayScale(base64);

        // Step 3: Get natural dimensions
        const { width: naturalWidth, height: naturalHeight } =
          await loadImageDimensions(base64);

        // Step 4: Resize to fit dynamically within maxWidth and maxHeight
        const maxWidth = 80; // maximum width in pt for 3-inch receipt
        const maxHeight = 40; // maximum height in pt
        const widthRatio = maxWidth / naturalWidth;
        const heightRatio = maxHeight / naturalHeight;
        const ratio = Math.min(widthRatio, heightRatio, 1); // don't upscale

        const imgWidth = naturalWidth * ratio;
        const imgHeight = naturalHeight * ratio;

        // Step 5: Center the logo
        const logoX = (pageWidth - imgWidth) / 2;

        doc.addImage(base64, "PNG", logoX, y, imgWidth, imgHeight);

        y += imgHeight + 20; // spacing after logo
      } catch (err) {
        console.warn("Logo failed to load:", err);
      }
    }

    // Header
    const invoiceTitle =
      data.status === "CANCELLED" ? "CANCELLED BILL RECIEPT" : "BILL RECIEPT";

    doc
      .setFont("NotoSansMono-Bold", "bold")
      .setFontSize(16)
      .text(invoiceTitle, pageWidth / 2, y, { align: "center" });
    y += 18;

    doc.setFontSize(14);
    const storeTitle = data.salefrom?.title || "Store";
    doc.splitTextToSize(storeTitle, pageWidth - 30).forEach((line) => {
      doc.text(line, pageWidth / 2, y, { align: "center" });
      y += 16;
    });

    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(14);
    if (data.salefrom?.phone) {
      doc.text(`Ph: ${data.salefrom.phone}`, pageWidth / 2, y, {
        align: "center",
      });
      y += 16;
    }

    const seller = data.salefrom;
    const sellerAddressParts = [
      seller?.addressline1,
      [seller?.state, seller?.district, seller?.country]
        .filter(Boolean)
        .join(", "),
      seller?.pincode ? `- ${seller?.pincode}` : null,
    ].filter(Boolean);

    doc
      .splitTextToSize(sellerAddressParts.join(", "), pageWidth - 30)
      .forEach((line) => {
        doc.text(line, pageWidth / 2, y, { align: "center" });
        y += 16;
      });

    if (seller?.email) {
      doc.text(`Email: ${seller?.email || ""}`, pageWidth / 2, y, {
        align: "center",
      });
      y += 16;
    }

    doc.setLineDash([1], 0);
    doc.line(8, y, pageWidth - 8, y);
    doc.setLineDash([]);
    y += 16;

    const { date, time } = saleTime;
    const labelX = 8; // Left-aligned label start
    const colonX = 110; // Colon aligned at this point
    const valueX = 120; // Value starts after colon
    const lineHeight = 17;
    const drawRowWithColonAligned = (label, value, yPos, isBold = false) => {
      const font = isBold ? "NotoSansMono-Bold" : "NotoSansMono-Regular";
      doc.setFont(font, isBold ? "bold" : "normal").setFontSize(15);
      doc.text(label, labelX, yPos);
      doc.text(":", colonX, yPos);
      doc.text(value, valueX, yPos);
    };
    drawRowWithColonAligned("Bill No", `${data.saleno}`, y);
    y += lineHeight + 2;
    drawRowWithColonAligned("Date", `${date}, ${time}`, y);
    y += lineHeight + 6;
    drawRowWithColonAligned(
      "Total Amount",
      `₹${CurrencyConverter.toCurrency(data.grandtotal || 0, "INR")}`,
      y,
      true
    );
    y += 12;

    doc.setLineDash([1], 0);
    doc.line(8, y, pageWidth - 8, y);
    y += 16;

    const buyer = data.saleto;
    const hasBuyerInfo =
      buyer &&
      (buyer?.name ||
        buyer?.phone ||
        buyer?.addressline1 ||
        buyer?.email ||
        buyer?.gstnumber ||
        buyer?.pannumber ||
        buyer?.cinnumber);

    if (hasBuyerInfo) {
      doc.setFont("NotoSansMono-Regular", "normal").setFontSize(14);
      doc.text("BUYER INFORMATION", pageWidth / 2, y, { align: "center" });
      y += 18;

      if (buyer.name) {
        doc.text(`${buyer.name}`, 10, y);
        y += 16;
      }
      if (buyer.phone) {
        doc.text(`Ph: ${buyer.phone}`, 10, y);
        y += 16;
      }

      const addressParts = [
        buyer.addressline1,
        [buyer.state, buyer.district, buyer.country].filter(Boolean).join(", "),
        buyer.pincode ? `- ${buyer.pincode}` : null,
      ].filter(Boolean);

      doc
        .splitTextToSize(addressParts.join(", "), pageWidth - 20)
        .forEach((line) => {
          doc.text(line, 11, y);
          y += 16;
        });

      if (buyer.email) {
        doc.text(`Email: ${buyer.email}`, 10, y);
        y += 16;
      }
      doc.setLineDash([1], 0);
      doc.line(8, y, pageWidth - 8, y);
      doc.setLineDash([]);
      y += 12;
    }

    const itemRows = [
      [
        {
          content: "",
          colSpan: 4,
          styles: {
            fontSize: 14,
            cellPadding: 2,
            lineWidth: 0,
            halign: "center",
          },
        },
      ],
      ...data.saleitems.flatMap((item) => {
        const rows = [];

        // Title + Note in single line
        let titleWithNote = item.title;
        if (item.imode === "PRODUCT" && item.note) {
          titleWithNote += ` (${item.note})`;
        }

        rows.push([
          {
            content: titleWithNote,
            colSpan: 4,
          },
        ]);

        // Price row
        rows.push([
          "",
          `₹${CurrencyConverter.toCurrency(item.soldprice || 0, "INR")}`,
          `${item.quantity}`,
          `₹${CurrencyConverter.toCurrency(
            item.lineTotalSoldPrice || 0,
            "INR"
          )}`,
        ]);

        return rows;
      }),
    ];

    autoTable(doc, {
      startY: y,
      head: [
        [
          {
            content: "Item",
            colSpan: 4,
            styles: {
              halign: "left",
              fontStyle: "bold",
              font: "NotoSansMono-Bold",
            },
          },
        ],
        [
          { content: "", styles: { cellPadding: 0 } },
          {
            content: "Rate",
            styles: {
              halign: "center",
              fontStyle: "bold",
              font: "NotoSansMono-Bold",
            },
          },
          {
            content: "Qty",
            styles: {
              halign: "center",
              fontStyle: "bold",
              font: "NotoSansMono-Bold",
            },
          },
          {
            content: "Total",
            styles: {
              halign: "right",
              fontStyle: "bold",
              font: "NotoSansMono-Bold",
            },
          },
        ],
      ],
      body: itemRows,
      theme: "plain",
      styles: {
        fontSize: 14,
        cellPadding: 3,
        lineWidth: 0,
        font: "NotoSansMono-Regular",
      },
      columnStyles: {
        0: { halign: "left" },
        1: { halign: "center" },
        2: { halign: "center" },
        3: { halign: "right" },
      },
      margin: { left: 8, right: 8 },
      didDrawCell: (data) => {
        const pageWidth = doc.internal.pageSize.getWidth();
        const left = 8;
        const right = pageWidth - 8;

        if (
          data.row.section === "head" &&
          data.row.index === 1 &&
          data.column.index === 3
        ) {
          const bottom = data.cell.y + data.cell.height + 2;
          doc.setLineDash([1, 1], 0);
          doc.setDrawColor(0);
          doc.line(left, bottom, right, bottom);
          doc.setLineDash([]);
        }
        if (
          data.row.section === "body" &&
          data.row.index === itemRows.length - 1 &&
          data.column.index === 0
        ) {
          const bottom = data.cell.y + data.cell.height + 2;
          doc.setLineDash([1, 1], 0);
          doc.setDrawColor(0);
          doc.line(left, bottom, right, bottom);
          doc.setLineDash([]);
        }
      },
    });

    y = doc.lastAutoTable.finalY + 18;
    y = checkPageBreak(doc, y);
    doc.setFontSize(14);
    doc.text(`Total Item: ${data.totalItems}`, 8, y);
    y += 24;
    doc.setFont("NotoSansMono-Bold", "bold").setFontSize(18);
    doc.text(
      `Total Amount: ₹${CurrencyConverter.toCurrency(
        data.grandtotal || 0,
        "INR"
      )}.00`,
      8,
      y
    );
    y += 12;

    doc.setLineDash([1, 1], 0);
    doc.line(10, y, pageWidth - 10, y);
    y += 18;
    y = checkPageBreak(doc, y);
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(14);
    if (parseFloat(data.totaldiscount) > 0) {
      doc.text("**** YOU SAVED ****", pageWidth / 2, y, { align: "center" });
      y += 16;
    }
    if (parseFloat(data.totaldiscount) > 0) {
      doc.text(
        `₹${CurrencyConverter.toCurrency(data.totaldiscount, "INR")}`,
        pageWidth / 2,
        y,
        { align: "center" }
      );
    }
    y += 18;
    y = checkPageBreak(doc, y);
    doc.setFontSize(14);
    doc.text("Thank you for your purchase!", pageWidth / 2, y, {
      align: "center",
    });
    y += 20;
    doc.setFont("NotoSansMono-Bold", "bold");
    doc.text("** Visit us Again **", pageWidth / 2, y, { align: "center" });
    if (storeSettings?.negobillBranding) {
      y += 20;
      doc.setFont("NotoSansMono-Regular", "normal").setFontSize(14);

      const payLabelX = 10;
      const payColonX = 125; // same column for all :
      const payValueX = 132; // amount starts just after :

      const drawPaymentRow = (label, amount, isBold = false) => {
        if (Number(amount) > 0) {
          y = checkPageBreak(doc, y);

          doc.setFont(
            isBold ? "NotoSansMono-Bold" : "NotoSansMono-Regular",
            isBold ? "bold" : "normal"
          );
          doc.setFontSize(14);

          doc.text(label, payLabelX, y);
          doc.text(":", payColonX, y);
          doc.text(
            `₹${CurrencyConverter.toCurrency(amount, "INR")}`,
            payValueX,
            y
          );

          y += 14;
        }
      };

      // ---------- PAYMENT MODE HEADER ----------
      doc.setLineDash([1, 1], 0);
      doc.line(8, y, pageWidth - 8, y);
      doc.setLineDash([]);
      y += 12;

      doc.setFont("NotoSansMono-Bold", "bold").setFontSize(14);
      doc.text("PAYMENT MODE", pageWidth / 2, y + 1, { align: "center" });
      y += 16;

      // ---------- PAYMENT VALUES ----------
      doc.setFont("NotoSansMono-Regular", "normal");

      // Adjusted values
      const cashPaid = (data.cashamount || 0) - (data.cashchange || 0);

      const cardPaid = (data.cardamount || 0) - (data.cardchange || 0);

      const onlinePaid = (data.onlineamount || 0) - (data.onlinechange || 0);

      const upiPaid = (data.upiamount || 0) - (data.upichange || 0);

      const balanceDue =
        (data.paylateramount || 0) - (data.paylaterchange || 0);

      // Draw only if value > 0
      drawPaymentRow("Cash", cashPaid);
      drawPaymentRow("Card", cardPaid);
      drawPaymentRow("Online Pay", onlinePaid);
      drawPaymentRow("UPI", upiPaid);

      // ---------- BALANCE DUE ----------
      if (balanceDue > 0) {
        y += 6;
        drawPaymentRow("Balance Due", balanceDue, true);
      }

      // ---------- FOOTER LINE ----------
      y += 4;
      doc.setLineDash([1, 1], 0);
      doc.line(8, y, pageWidth - 8, y);
      doc.setLineDash([]);
      y += 16;

      doc.setFont("NotoSansMono-Regular", "normal");
      doc.text("Powered By", pageWidth / 2, y, { align: "center" });
      y += 18;

      doc.setFontSize(10);
      const sitePrefix = "www.";
      const siteBold = "NegoBill";
      const siteSuffix = ".com";
      const prefixWidth = doc.getTextWidth(sitePrefix);
      const boldWidth = doc.getTextWidth(siteBold);
      const suffixWidth = doc.getTextWidth(siteSuffix);
      const totalWidth = prefixWidth + boldWidth + suffixWidth;
      const startX = (pageWidth - totalWidth) / 2;

      doc.setFont("NotoSansMono-Regular", "normal");
      doc.text(sitePrefix, startX, y);
      doc.setFont("NotoSansMono-Bold", "bold");
      doc.text(siteBold, startX + prefixWidth, y);
      doc.setFont("NotoSansMono-Regular", "normal");
      doc.text(siteSuffix, startX + prefixWidth + boldWidth, y);
    }
    // setPrint(false);
    return doc;
  };

  const handleDownload = async (data) => {
    setDownload(true);
    const { salemode, saleno } = data || {};

    let doc;

    if (salemode?.toUpperCase() === "BILL") {
      doc = await generate4InchBillReceipt();
    } else {
      doc = await generate3InchinvoiceReceiptM2();
    }

    const filenamePrefix = formatTrackMode(selectedSize)?.replace(/\s+/g, "_");
    doc.save(`${filenamePrefix}_${saleno}.pdf`);
  };

  const handlePrint = async (data, overrideSize = null) => {
    setPrint(true);
    try {
      if (!checkNetwork()) return;

      const paperSize = overrideSize || selectedSize;
      const upperMode = data?.salemode?.toUpperCase();
      let doc;

      if (paperSize === "BILL") {
        doc = await generate4InchBillReceipt();
      } else {
        doc = await generate3InchinvoiceReceiptM2();
      }
      const pdfBase64 = doc.output("datauristring").split(",")[1];
      const response = await handlePrintSystem(pdfBase64, "TVS-E RP 3230");

      if (!response) {
        const blob = doc.output("blob");
        const blobUrl = URL.createObjectURL(blob);

        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "none";
        iframe.src = blobUrl;
        document.body.appendChild(iframe);

        iframe.onload = () => {
          setTimeout(() => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          }, 500);
        };
      }
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setPrint(false);
    }
  };

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal"
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);
  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS(
          "NotoSansMono_24pt-Regular-normal.ttf",
          NotoSansMonoReular
        );
        this.addFileToVFS(
          "NotoSansMono_24pt-Bold-normal.ttf",
          NotoSansMonoBold
        );
        this.addFont(
          "NotoSansMono_24pt-Regular-normal.ttf",
          "NotoSansMono-Regular",
          "normal"
        );
        this.addFont(
          "NotoSansMono_24pt-Bold-normal.ttf",
          "NotoSansMono-Bold",
          "bold"
        );
      },
    ]);
  }, []);

  useEffect(() => {
    setData(isViewData);
  }, [isViewData]);
  useEffect(() => {
    setTerms(storeSettings?.invoiceSettings?.termsAndConditions);
  }, [storeSettings?.invoiceSettings]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "p") {
        event.preventDefault();
        handlePrint(data);
      }
    };
    const handleAfterPrint = () => {
      setTimeout(() => {
        window.focus();
      }, 100);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, [data]);

  return (
    <>
      <div className="invoice-Thermalscale">
        {selectedSize === "BILL" ? (
          <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1">
                <div className="tm_invoice_in row">
                  <div className="col-12">
                    <table width="100%" className="pdfcontent border">
                      <tbody>
                        <tr>
                          <td width="100%" className="text-center">
                            <div className="tm_logo">
                              {("/assets/images/logo-light.png" ||
                                settings?.saleProfileData?.image) && (
                                <img
                                  src={
                                    settings?.saleProfileData?.image
                                      ? uRLs.IMAGE_URL +
                                        "profile/" +
                                        settings?.saleProfileData?.image
                                      : "/assets/images/logo-light.png"
                                  }
                                  className="img-rounded logo mb-0"
                                  height="50"
                                />
                              )}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td width="100%" className="text-center">
                            {/* <div className="tm_primary_color fs-24 tm_text_uppercase mt-2">
                          {isViewData?.salemode &&
                            formatTrackMode(isViewData?.salemode)}
                        </div> */}
                            {isViewData?.status === "CANCELLED" && (
                              <span className="badge rounded-pill bg-label-danger mt-3 fs-15 tm_text_uppercase">
                                {isViewData?.status}
                              </span>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td className="text-center">
                            <div
                              style={{
                                fontSize: "20px",
                                fontWeight: "600",
                                marginBottom: "0px",
                              }}
                            >
                              {settings?.saleProfileData?.title || ""}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className="text-center">
                            <div
                              style={{
                                fontSize: "16px",
                                lineHeight: "18px",
                                marginBottom: "0px",
                              }}
                            >
                              <div>
                                {settings?.saleProfileData?.addressline1 || ""}{" "}
                                {settings?.saleProfileData?.addressline2 || ""}{" "}
                                {settings?.saleProfileData?.district || ""}{" "}
                                {settings?.saleProfileData?.country || ""} -{" "}
                                {settings?.saleProfileData?.pincode || ""}
                              </div>
                              <div>
                                Phone: +91{" "}
                                {settings?.saleProfileData?.phone || ""}
                              </div>
                              <div>
                                Email: {settings?.saleProfileData?.email || ""}
                              </div>
                              {settings?.saleProfileData?.gstnumber && (
                                <div>
                                  <strong>GST:</strong>{" "}
                                  {settings?.saleProfileData?.gstnumber || ""}
                                </div>
                              )}
                              {settings?.saleProfileData?.fssai && (
                                <div>
                                  <strong>FSSAI:</strong>{" "}
                                  {settings?.saleProfileData?.fssai}
                                </div>
                              )}
                              {settings?.saleProfileData?.pannumber && (
                                <div>
                                  <strong>PAN:</strong>{" "}
                                  {settings?.saleProfileData?.pannumber || ""}
                                </div>
                              )}
                              <div>
                                <strong>State:</strong>{" "}
                                {settings?.saleProfileData?.state || ""} [ State
                                Code :
                                {settings?.saleProfileData?.statecode || ""} ]
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    {/* <div className="tm_invoice_info tm_mb20 mt-2">
                  <div
                    className="tm_invoice_seperator1 tm_gray_bg_dark"
                    style={{
                      backgroundColor:
                        selectedTheme?.templateTheme?.primaryColor,
                    }}
                  ></div>
                </div> */}
                    <div className="p-2 border">
                      <div className="d-flex">
                        <span
                          style={{
                            fontSize: "18px",
                            lineHeight: "22px",
                            marginBottom: "0px",
                            fontWeight: "600",
                          }}
                        >
                          {isViewData?.salemode &&
                            formatTrackMode(isViewData?.salemode)}
                        </span>
                      </div>
                      <div className="d-flex">
                        <span
                          style={{
                            fontSize: "16px",
                            lineHeight: "22px",
                            marginBottom: "0px",
                          }}
                        >
                          Invoice No:
                        </span>
                        <span
                          style={{
                            fontSize: "18px",
                            lineHeight: "22px",
                            marginBottom: "0px",
                            fontWeight: "600",
                          }}
                        >
                          {isViewData?.saleno}
                        </span>
                      </div>
                      <div className="d-flex">
                        <span
                          style={{
                            fontSize: "16px",
                            lineHeight: "22px",
                            marginBottom: "0px",
                          }}
                        >
                          Invoice Date:
                        </span>
                        <span
                          style={{
                            fontSize: "18px",
                            lineHeight: "22px",
                            marginBottom: "0px",
                            fontWeight: "600",
                          }}
                        >
                          {saleTime?.date}
                          {","}
                          {saleTime?.time}
                        </span>
                      </div>
                    </div>
                    {/* <table width="100%">
                  <tbody>
                    <tr>
                      <td width="40%" className="text-Start">
                        <div
                          style={{
                            fontSize: "20px",
                            lineHeight: "22px",
                            marginBottom: "0px",
                          }}
                        >
                          Invoice No
                        </div>
                      </td>
                      <td width="20%" className="text-Start">
                        :
                      </td>
                      <td width="40%" className="text-Start">
                        <div
                          style={{
                            fontSize: "20px",
                            lineHeight: "22px",
                            marginBottom: "0px",
                          }}
                        >
                          {isViewData?.saleno}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td width="40%" className="text-Start">
                        <div
                          style={{
                            fontSize: "20px",
                            lineHeight: "22px",
                            marginBottom: "0px",
                          }}
                        >
                          Date
                        </div>
                      </td>
                      <td width="20%" className="text-Start">
                        :
                      </td>
                      <td width="40%" className="text-Start">
                        <div
                          style={{
                            fontSize: "20px",
                            lineHeight: "22px",
                            marginBottom: "0px",
                          }}
                        >
                          {saleTime?.date}
                          {","}
                          {saleTime?.time}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td width="40%" className="text-Start">
                        <div
                          style={{
                            fontSize: "20px",
                            lineHeight: "22px",
                            fontWeight: "600",
                            marginBottom: "0px",
                          }}
                        >
                          Total Amount
                        </div>
                      </td>
                      <td width="20%" className="text-Start">
                        :
                      </td>
                      <td width="40%" className="text-Start mb-1">
                        <div
                          style={{
                            fontSize: "20px",
                            lineHeight: "22px",
                            fontWeight: "600",
                            marginBottom: "0px",
                          }}
                        >
                          ₹
                          {CurrencyConverter.toCurrency(
                            isViewData?.grandtotal || 0,
                            "INR"
                          )}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table> */}

                    {/* <div className="tm_invoice_info tm_mb20 mb-2">
                  <div
                    className="tm_invoice_seperator1 tm_gray_bg_dark"
                    style={{
                      backgroundColor:
                        selectedTheme?.templateTheme?.primaryColor,
                    }}
                  ></div>
                </div> */}
                    <table width="100%" className="border">
                      <tbody>
                        <tr>
                          <td width="100%" className="text-center p-2">
                            <div
                              style={{
                                fontSize: "20px",
                                fontWeight: "600",
                                marginBottom: "0px",
                              }}
                            >
                              BUYER INFORMATION
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            width="100%"
                            style={{ verticalAlign: "top" }}
                            className="p-2"
                          >
                            {isViewData?.saleto &&
                              (isViewData?.saleto?.name ||
                                isViewData?.saleto?.addressline1 ||
                                isViewData?.saleto?.addressline2 ||
                                isViewData?.saleto?.state ||
                                isViewData?.saleto?.district ||
                                isViewData?.saleto?.country ||
                                isViewData?.saleto?.pincode ||
                                isViewData?.saleto?.phone ||
                                isViewData?.saleto?.email ||
                                isViewData?.saleto?.gstnumber ||
                                isViewData?.saleto?.statecode ||
                                isViewData?.saleto?.referid) && (
                                <div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    {isViewData?.saleto?.name || ""}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      lineHeight: "18px",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    <div>
                                      {isViewData?.saleto?.addressline1 || ""}{" "}
                                      {isViewData?.saleto?.addressline2 || ""}{" "}
                                      {isViewData?.saleto?.state || ""}{" "}
                                      {isViewData?.saleto?.district || ""}{" "}
                                      {isViewData?.saleto?.country || ""} -{" "}
                                      {isViewData?.saleto?.pincode || ""}
                                    </div>
                                    {isViewData?.saleto?.phone && (
                                      <div>
                                        Phone: +91 {isViewData?.saleto?.phone}
                                      </div>
                                    )}
                                    {isViewData?.saleto?.email && (
                                      <div>
                                        Email: {isViewData?.saleto?.email}
                                      </div>
                                    )}
                                    {isViewData?.saleto?.gstnumber && (
                                      <div>
                                        <strong>GST:</strong>{" "}
                                        {isViewData?.saleto?.gstnumber}
                                      </div>
                                    )}
                                    {isViewData?.saleto?.state && (
                                      <div>
                                        <strong>State:</strong>{" "}
                                        {isViewData?.saleto?.state} [ State Code
                                        :{isViewData?.saleto?.statecode || ""} ]
                                      </div>
                                    )}
                                    {isViewData?.saleto?.referid && (
                                      <div>
                                        <strong>Reference ID:</strong>{" "}
                                        {isViewData?.saleto?.referid}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {/* <div className="tm_invoice_info tm_mb20 my-2">
                  <div
                    className="tm_invoice_seperator1 tm_gray_bg_dark"
                    style={{
                      backgroundColor:
                        selectedTheme?.templateTheme?.primaryColor,
                    }}
                  ></div>
                </div> */}
                    <table width="100%" className="border">
                      <tbody>
                        <tr>
                          <td colSpan={4} className="text-start mb-1 p-2">
                            <div
                              style={{
                                fontSize: "20px",
                                lineHeight: "22px",
                                fontWeight: "600",
                              }}
                            >
                              Items
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td width="10%"></td>

                          <td width="30%" className="text-start mb-1">
                            <div
                              style={{
                                fontSize: "20px",
                                lineHeight: "22px",
                                fontWeight: "600",
                              }}
                            >
                              Rate
                            </div>
                          </td>

                          <td width="30%" className="text-start mb-1">
                            <div
                              style={{
                                fontSize: "20px",
                                lineHeight: "22px",
                                fontWeight: "600",
                              }}
                            >
                              Qty
                            </div>
                          </td>

                          <td width="30%" className="text-start mb-1">
                            <div
                              style={{
                                fontSize: "20px",
                                lineHeight: "22px",
                                fontWeight: "600",
                              }}
                            >
                              Total
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <div className="tm_invoice_info tm_mb20 mt-2">
                              <div
                                className="tm_invoice_seperator1 tm_gray_bg_dark"
                                // style={{
                                //   backgroundColor:
                                //     selectedTheme?.templateTheme?.primaryColor,
                                // }}
                              ></div>
                            </div>
                          </td>
                        </tr>
                        {isViewData?.saleitems?.map((product, index) => (
                          <>
                            <tr>
                              <td colSpan={4} className="text-start mb-1 p-2">
                                <div
                                  style={{
                                    fontSize: "18px",
                                    lineHeight: "22px",
                                  }}
                                >
                                  {product?.title}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td width="10%"></td>

                              <td width="30%" className="text-start mb-1">
                                <div
                                  style={{
                                    fontSize: "18px",
                                    lineHeight: "22px",
                                  }}
                                >
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    product?.soldprice || 0,
                                    "INR"
                                  )}
                                </div>
                              </td>

                              <td width="30%" className="text-start mb-1">
                                <div
                                  style={{
                                    fontSize: "18px",
                                    lineHeight: "22px",
                                  }}
                                >
                                  {product?.quantity}
                                </div>
                              </td>

                              <td width="30%" className="text-start mb-1">
                                <div
                                  style={{
                                    fontSize: "18px",
                                    lineHeight: "22px",
                                  }}
                                >
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    product.lineTotalSoldPrice || 0,
                                    "INR"
                                  )}
                                </div>
                              </td>
                            </tr>
                          </>
                        ))}
                      </tbody>
                    </table>
                    {/* <div className="tm_invoice_info tm_mb20 my-2">
                  <div
                    className="tm_invoice_seperator1 tm_gray_bg_dark"
                    style={{
                      backgroundColor:
                        selectedTheme?.templateTheme?.primaryColor,
                    }}
                  ></div>
                </div> */}
                    <table width="100%" className="border">
                      <tbody>
                        <tr>
                          <td width="100%" className="p-2 pb-0">
                            <div style={{ fontSize: "18px" }}>
                              Total Item : {isViewData?.totalqty}
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td width="100%" className="p-2">
                            <div
                              style={{ fontSize: "20px", fontWeight: "600" }}
                            >
                              Total Amount :{" "}
                              {CurrencyConverter.toCurrency(
                                isViewData?.grandtotal || 0,
                                "INR"
                              )}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {/* <div className="tm_invoice_info tm_mb20 my-2">
                  <div
                    className="tm_invoice_seperator1 tm_gray_bg_dark"
                    style={{
                      backgroundColor:
                        selectedTheme?.templateTheme?.primaryColor,
                    }}
                  ></div>
                </div> */}
                    <table width="100%" className="border">
                      <tbody>
                        <tr>
                          <td
                            className="p-2"
                            style={{
                              fontSize: "20px",
                              textAlign: "center",
                              padding: "8px",
                              color: "black",
                            }}
                          >
                            ***** YOU SAVED *****
                            <div className="mt-1" style={{ fontSize: "20px" }}>
                              ₹
                              {CurrencyConverter.toCurrency(
                                isViewData?.totaldiscount || 0,
                                "INR"
                              )}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {/* <div className="tm_invoice_info tm_mb20 my-2">
                  <div
                    className="tm_invoice_seperator1 tm_gray_bg_dark"
                    style={{
                      backgroundColor:
                        selectedTheme?.templateTheme?.primaryColor,
                    }}
                  ></div>
                  </div> */}
                    {Object.keys(taxRows || {})?.length > 0 && (
                      <table width="100%" className="border">
                        <tbody>
                          <tr>
                            <td
                              style={{
                                fontSize: "20px",
                                textAlign: "center",
                                padding: "8px",
                                color: "black",
                                fontWeight: "600",
                              }}
                            >
                              Tax
                            </td>
                            <td
                              style={{
                                fontSize: "20px",
                                textAlign: "center",
                                padding: "8px",
                                color: "black",
                                fontWeight: "600",
                              }}
                            >
                              Amount
                            </td>
                            {isIGST ? (
                              <td
                                style={{
                                  fontSize: "20px",
                                  textAlign: "center",
                                  padding: "8px",
                                  color: "black",
                                  fontWeight: "600",
                                }}
                              >
                                IGST
                              </td>
                            ) : (
                              <>
                                {" "}
                                <td
                                  style={{
                                    fontSize: "20px",
                                    textAlign: "center",
                                    padding: "8px",
                                    color: "black",
                                    fontWeight: "600",
                                  }}
                                >
                                  SGST
                                </td>
                                <td
                                  style={{
                                    fontSize: "20px",
                                    textAlign: "center",
                                    padding: "8px",
                                    color: "black",
                                    fontWeight: "600",
                                  }}
                                >
                                  CGST
                                </td>
                              </>
                            )}
                          </tr>
                          {Object.entries(taxRows || {})
                            .filter(([percent]) => parseFloat(percent) > 0)
                            .map(([percent, t]) => (
                              <tr key={percent}>
                                <td
                                  style={{
                                    fontSize: "18px",
                                    textAlign: "center",
                                    padding: "8px",
                                    color: "black",
                                  }}
                                >
                                  {percent}%
                                </td>
                                <td
                                  style={{
                                    fontSize: "18px",
                                    textAlign: "center",
                                    padding: "8px",
                                    color: "black",
                                  }}
                                >
                                  {CurrencyConverter.toCurrency(
                                    t.basePrice || 0,
                                    "INR"
                                  )}
                                </td>
                                {isIGST ? (
                                  <td
                                    style={{
                                      fontSize: "18px",
                                      textAlign: "center",
                                      padding: "8px",
                                      color: "black",
                                    }}
                                  >
                                    {CurrencyConverter.toCurrency(
                                      t.igst || 0,
                                      "INR"
                                    )}
                                  </td>
                                ) : (
                                  <>
                                    <td
                                      style={{
                                        fontSize: "18px",
                                        textAlign: "center",
                                        padding: "8px",
                                        color: "black",
                                      }}
                                    >
                                      {CurrencyConverter.toCurrency(
                                        t.sgst || 0,
                                        "INR"
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "18px",
                                        textAlign: "center",
                                        padding: "8px",
                                        color: "black",
                                      }}
                                    >
                                      {CurrencyConverter.toCurrency(
                                        t.cgst || 0,
                                        "INR"
                                      )}
                                    </td>
                                  </>
                                )}
                              </tr>
                            ))}
                          <tr>
                            <td colSpan={4}>
                              <div className="tm_invoice_info tm_mb20 mt-2">
                                <div
                                  className="tm_invoice_seperator1 tm_gray_bg_dark"
                                  //   style={{
                                  //     backgroundColor:
                                  //       selectedTheme?.templateTheme?.primaryColor,
                                  //   }}
                                ></div>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td
                              colSpan={2}
                              style={{
                                fontSize: "18px",
                                textAlign: "left",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              TotalTax
                            </td>
                            <td
                              colSpan={2}
                              style={{
                                fontSize: "18px",
                                textAlign: "end",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              {CurrencyConverter.toCurrency(
                                data.totaltaxamount || 0,
                                "INR"
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                    {/* <div className="tm_invoice_info tm_mb20 my-2">
                  <div
                    className="tm_invoice_seperator1 tm_gray_bg_dark"
                    style={{
                      backgroundColor:
                        selectedTheme?.templateTheme?.primaryColor,
                    }}
                  ></div>
                  </div> */}
                    <div className="p-2 border">
                      <div
                        className="mt-1 text-center"
                        style={{ fontSize: "20px" }}
                      >
                        Thank you for your purchase
                      </div>
                      <div
                        className="mt-1 text-center"
                        style={{ fontSize: "20px", fontWeight: "600" }}
                      >
                        ** Visit us Again **
                      </div>
                    </div>

                    <table width="100%" className="border">
                      <tbody>
                        <tr>
                          <td
                            colSpan={3}
                            className="text-center"
                            style={{
                              fontSize: "18px",
                              textAlign: "start",
                              padding: "8px",
                              color: "black",
                              fontWeight: "600",
                            }}
                          >
                            {" "}
                            PAYMENT MODE
                          </td>
                        </tr>
                        {cashPaid > 0 && (
                          <tr>
                            <td
                              style={{
                                fontSize: "18px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              Cash
                            </td>
                            <td
                              style={{
                                fontSize: "18px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontSize: "18px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              {CurrencyConverter.toCurrency(
                                cashPaid || 0,
                                "INR"
                              )}
                            </td>
                          </tr>
                        )}
                        {cardPaid > 0 && (
                          <tr>
                            <td
                              style={{
                                fontSize: "18px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              Card
                            </td>
                            <td
                              style={{
                                fontSize: "18px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontSize: "18px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              {CurrencyConverter.toCurrency(
                                cardPaid || 0,
                                "INR"
                              )}
                            </td>
                          </tr>
                        )}
                        {onlinePaid > 0 && (
                          <tr>
                            <td
                              style={{
                                fontSize: "18px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              Online
                            </td>
                            <td
                              style={{
                                fontSize: "18px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontSize: "18px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              {CurrencyConverter.toCurrency(
                                onlinePaid || 0,
                                "INR"
                              )}
                            </td>
                          </tr>
                        )}
                        {upiPaid > 0 && (
                          <tr>
                            <td
                              style={{
                                fontSize: "18px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              UPI
                            </td>
                            <td
                              style={{
                                fontSize: "18px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontSize: "18px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              {CurrencyConverter.toCurrency(upiPaid || 0)}
                            </td>
                          </tr>
                        )}
                        {balanceDue > 0 && (
                          <tr>
                            <td
                              style={{
                                fontSize: "18px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              BalanceDue
                            </td>
                            <td
                              style={{
                                fontSize: "18px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontSize: "18px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              {CurrencyConverter.toCurrency(balanceDue || 0)}
                            </td>
                          </tr>
                        )}
                        {/* <tr><td colSpan={3}><div className="tm_invoice_info tm_mb20 my-2">
                  <div
                    className="tm_invoice_seperator1 tm_gray_bg_dark"
                    style={{
                      backgroundColor:
                        selectedTheme?.templateTheme?.primaryColor,
                    }}
                  ></div>
                  </div></td></tr> */}
                      </tbody>
                    </table>
                    {storeSettings?.negobillBranding && (
                      <>
                        <div
                          className="mt-1 text-center"
                          style={{ fontSize: "20px" }}
                        >
                          Powered By
                        </div>
                        <div
                          className="mt-1 text-center"
                          style={{ fontSize: "18px", fontWeight: "600" }}
                        >
                          www.NegoBill.com
                        </div>
                      </>
                    )}
                    {/* {terms?.length > 0 && (
                  <table width="100%" style={{ marginLeft: "10px" }}>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            padding: "8px",
                          }}
                        >
                          <div
                            className="fs-13 fw-600"
                            style={{
                              textAlign: "left",
                              color: "black",
                            }}
                          >
                            Terms & Conditions
                          </div>
                          
                          {terms}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : selectedSize === "INVOICE" ? (
          <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1">
                <div className="tm_invoice_in row d-flex justify-content-center">
                  <div className="col-12">
                    <table width="100%" className="pdfcontent">
                      <tbody>
                        <tr>
                          <td width="100%" className="text-center">
                            <div className="tm_logo">
                              {("/assets/images/logo-light.png" ||
                                settings?.saleProfileData?.image) && (
                                <img
                                  src={
                                    settings?.saleProfileData?.image
                                      ? uRLs.IMAGE_URL +
                                        "profile/" +
                                        settings?.saleProfileData?.image
                                      : "/assets/images/logo-light.png"
                                  }
                                  className="img-rounded logo mb-0"
                                  height="40"
                                />
                              )}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td width="100%" className="text-center">
                            {/* <div className="tm_primary_color fs-24 tm_text_uppercase mt-2">
                          {isViewData?.salemode &&
                            formatTrackMode(isViewData?.salemode)}
                        </div> */}
                            {globalData?.status === "CANCELLED" && (
                              <span className="badge rounded-pill bg-label-danger mt-3 fs-15 tm_text_uppercase">
                                {globalData?.status}
                              </span>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td className="text-center">
                            <div
                              style={{
                                fontSize: "17px",
                                fontWeight: "600",
                                marginBottom: "0px",
                              }}
                            >
                              {settings?.saleProfileData?.title || ""}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className="text-center">
                            <div
                              style={{
                                fontSize: "12px",
                                lineHeight: "18px",
                                marginBottom: "0px",
                              }}
                            >
                              <div>
                                {settings?.saleProfileData?.addressline1 || ""}{" "}
                                {settings?.saleProfileData?.addressline2 || ""}{" "}
                              </div>
                              <div>
                                {settings?.saleProfileData?.district || ""}{" "}
                                {settings?.saleProfileData?.country || ""} -{" "}
                                {settings?.saleProfileData?.pincode || ""}
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              fontSize: "12px",
                              lineHeight: "18px",
                              marginBottom: "0px",
                            }}
                            className="d-flex justify-content-between"
                          >
                            {settings?.saleProfileData?.gstnumber && (
                              <div>
                                GST:
                                {settings?.saleProfileData?.gstnumber || ""}
                              </div>
                            )}
                            <div>
                              Ph: {settings?.saleProfileData?.phone || ""}
                            </div>
                          </td>
                          <td
                            style={{
                              fontSize: "12px",
                              lineHeight: "18px",
                              marginBottom: "0px",
                            }}
                            className="d-flex justify-content-between"
                          >
                            {settings?.saleProfileData?.fssai && (
                              <div>
                                FSSAI:
                                {settings?.saleProfileData?.fssai || ""}
                              </div>
                            )}
                            <div>
                              PAN: {settings?.saleProfileData?.pannumber || ""}
                            </div>
                          </td>
                          <td
                            style={{
                              fontSize: "12px",
                              lineHeight: "18px",
                              marginBottom: "0px",
                            }}
                            className="d-flex justify-content-between"
                          >
                            {settings?.saleProfileData?.cinnumber && (
                              <div>
                                CIN:
                                {settings?.saleProfileData?.cinnumber || ""}
                              </div>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="d-flex align-items-center my-2">
                      <hr class="flex-grow-1 border-top border-2 border-dashed" />
                      <span class="px-2 fw-bold">
                        <div className="tm_invoice_in fs-17 tm_text_uppercase ">
                          {globalData?.salemode &&
                            formatTrackMode(globalData?.salemode)}
                        </div>
                      </span>
                      <hr class="flex-grow-1 border-top border-2 border-dashed" />
                    </div>
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td className="text-Start">
                            <div
                              style={{
                                fontSize: "15px",
                                lineHeight: "22px",
                                marginBottom: "0px",
                              }}
                            >
                              Invoice No : {globalData?.saleno}
                            </div>
                          </td>
                          {/* <td className="text-Start">
                        <div
                          style={{
                            fontSize: "15px",
                            lineHeight: "22px",
                            marginBottom: "0px",
                          }}
                        >
                          Counter :  02
                        </div>
                      </td> */}
                        </tr>
                        <tr>
                          <td width="60%" className="text-Start">
                            <div
                              style={{
                                fontSize: "15px",
                                lineHeight: "22px",
                                marginBottom: "0px",
                              }}
                            >
                              Date : {saleTime?.date}
                              {","}
                              {saleTime?.time}
                            </div>
                          </td>
                        </tr>
                        {/* <tr>
                      <td width="50%" className="text-Start">
                        <div
                          style={{
                            fontSize: "15px",
                            lineHeight: "22px",
                            marginBottom: "0px",
                          }}
                        >
                          Cashier : Stejo
                        </div>
                      </td>
                    </tr> */}
                      </tbody>
                    </table>
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td width="100%" className="text-center pt-2">
                            <div
                              style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                marginBottom: "0px",
                              }}
                            >
                              BUYER INFORMATION
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td width="100%" style={{ verticalAlign: "top" }}>
                            {globalData?.saleto &&
                              (globalData?.saleto?.name ||
                                globalData?.saleto?.addressline1 ||
                                globalData?.saleto?.addressline2 ||
                                globalData?.saleto?.state ||
                                globalData?.saleto?.district ||
                                globalData?.saleto?.country ||
                                globalData?.saleto?.pincode ||
                                globalData?.saleto?.phone ||
                                globalData?.saleto?.email ||
                                globalData?.saleto?.gstnumber ||
                                globalData?.saleto?.statecode ||
                                globalData?.saleto?.referid) && (
                                <div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    {globalData?.saleto?.name || ""}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "12px",
                                      lineHeight: "18px",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    {globalData?.saleto?.phone && (
                                      <div>
                                        Phone: +91 {globalData?.saleto?.phone} |
                                        Email: {globalData?.saleto?.email}
                                      </div>
                                    )}
                                    <div>
                                      {globalData?.saleto?.addressline1 || ""}{" "}
                                      {globalData?.saleto?.addressline2 || ""}{" "}
                                      {globalData?.saleto?.state || ""}{" "}
                                      {globalData?.saleto?.district || ""}{" "}
                                      {globalData?.saleto?.country || ""} -{" "}
                                      {globalData?.saleto?.pincode || ""}
                                    </div>

                                    {globalData?.saleto?.gstnumber && (
                                      <div>
                                        <strong>GST:</strong>{" "}
                                        {globalData?.saleto?.gstnumber}
                                      </div>
                                    )}
                                    {globalData?.saleto?.pannumber && (
                                      <div>
                                        <strong>PAN:</strong>{" "}
                                        {globalData?.saleto?.pannumber}
                                      </div>
                                    )}
                                    {globalData?.saleto?.cinnumber && (
                                      <div>
                                        <strong>CIN:</strong>{" "}
                                        {globalData?.saleto?.cinnumber}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table
                      width="100%"
                      className="rounded mt-2"
                      cellPadding="2"
                      style={{
                        border: "1px solid #c0bebe",
                      }}
                    >
                      <tbody>
                        <tr>
                          <td colSpan={4} className="text-start mb-1">
                            <div
                              style={{
                                fontSize: "17px",
                                lineHeight: "22px",
                                fontWeight: "600",
                              }}
                            >
                              Items
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td width="10%"></td>

                          <td width="30%" className="text-start mb-1">
                            <div
                              style={{
                                fontSize: "17px",
                                lineHeight: "22px",
                                fontWeight: "600",
                              }}
                            >
                              Rate
                            </div>
                          </td>

                          <td width="30%" className="text-start mb-1">
                            <div
                              style={{
                                fontSize: "17px",
                                lineHeight: "22px",
                                fontWeight: "600",
                              }}
                            >
                              Qty
                            </div>
                          </td>

                          <td width="30%" className="text-start mb-1">
                            <div
                              style={{
                                fontSize: "17px",
                                lineHeight: "22px",
                                fontWeight: "600",
                              }}
                            >
                              Total
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={4}>
                            <div className="tm_invoice_info tm_mb20 mt-2">
                              <div className="tm_invoice_seperator1 tm_gray_bg_dark"></div>
                            </div>
                          </td>
                        </tr>
                        {globalData?.saleitems?.map((product, index) => (
                          <>
                            <tr>
                              <td colSpan={4} className="text-start mb-1">
                                <div
                                  style={{
                                    fontSize: "15px",
                                    lineHeight: "22px",
                                  }}
                                >
                                  {product.title}
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td width="10%"></td>

                              <td width="30%" className="text-start mb-1">
                                <div
                                  style={{
                                    fontSize: "15px",
                                    lineHeight: "22px",
                                  }}
                                >
                                  ₹{product?.soldprice}
                                </div>
                              </td>

                              <td width="30%" className="text-start mb-1">
                                <div
                                  style={{
                                    fontSize: "15px",
                                    lineHeight: "22px",
                                  }}
                                >
                                  {product?.quantity}{" "}
                                  {(() => {
                                    const unitCode = product?.isSecondaryUnit
                                      ? product?.unitConfig?.secondaryUnitCode
                                      : product?.unitConfig?.primaryUnitCode;
                                    return unitCode || "";
                                  })()}
                                </div>
                              </td>

                              <td width="30%" className="text-start mb-1">
                                <div
                                  style={{
                                    fontSize: "15px",
                                    lineHeight: "22px",
                                  }}
                                >
                                  ₹{product.lineTotalSoldPrice}
                                </div>
                              </td>
                            </tr>
                          </>
                        ))}
                      </tbody>
                    </table>
                    <div className="row mt-2 g-2">
                      <div className="col-6">
                        <div
                          className=" rounded p-2 h-100"
                          style={{
                            border: "1px solid #c0bebe",
                          }}
                        >
                          {/* <div
                      className="d-flex justify-content-between mb-1"
                      style={{ fontSize: "15px" }}
                    >
                      <span>Qty :</span>
                      <span>{isViewData?.totalqty}</span>
                    </div> */}

                          <div
                            className="d-flex justify-content-between mb-1"
                            style={{ fontSize: "15px" }}
                          >
                            <span>Items : </span>
                            <span>{globalData?.totalqty}</span>
                          </div>
                        </div>
                      </div>

                      <div className="col-6">
                        <div
                          className=" rounded p-2 h-100 text-center"
                          style={{
                            border: "1px solid #c0bebe",
                          }}
                        >
                          <div style={{ fontSize: "15px", fontWeight: "600" }}>
                            Total Amount{" "}
                          </div>
                          <div style={{ fontSize: "15px", fontWeight: "600" }}>
                            ₹{globalData?.grandtotal}
                          </div>
                        </div>
                      </div>
                    </div>

                    <table
                      width="100%"
                      cellPadding={2}
                      className="rounded mt-2"
                      style={{
                        border: "1px solid #c0bebe",
                      }}
                    >
                      <tbody>
                        <tr>
                          <td
                            colSpan={3}
                            style={{
                              fontSize: "16px",
                              textAlign: "start",
                              padding: "8px",
                              color: "black",
                              fontWeight: "600",
                            }}
                          >
                            {" "}
                            PAYMENT MODE
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={3}>
                            <div className="tm_invoice_info tm_mb20 mt-2">
                              <div className="tm_invoice_seperator1 tm_gray_bg_dark"></div>
                            </div>
                          </td>
                        </tr>
                        {globalData.cashPaid > 0 && (
                          <tr>
                            <td
                              style={{
                                fontSize: "15px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              Cash
                            </td>
                            <td
                              style={{
                                fontSize: "15px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontSize: "15px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              ₹{globalData.cashPaid}
                            </td>
                          </tr>
                        )}
                        {globalData.cardPaid > 0 && (
                          <tr>
                            <td
                              style={{
                                fontSize: "15px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              Card
                            </td>
                            <td
                              style={{
                                fontSize: "15px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontSize: "15px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              ₹{globalData.cardPaid}
                            </td>
                          </tr>
                        )}
                        {globalData.onlinePaid > 0 && (
                          <tr>
                            <td
                              style={{
                                fontSize: "15px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              Online
                            </td>
                            <td
                              style={{
                                fontSize: "15px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontSize: "15px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              ₹{globalData.onlinePaid}
                            </td>
                          </tr>
                        )}
                        {globalData.upiPaid > 0 && (
                          <tr>
                            <td
                              style={{
                                fontSize: "15px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              UPI
                            </td>
                            <td
                              style={{
                                fontSize: "15px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontSize: "15px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              ₹{globalData.upiPaid}
                            </td>
                          </tr>
                        )}
                        {globalData.balanceDue > 0 && (
                          <tr>
                            <td
                              style={{
                                fontSize: "15px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              BalanceDue
                            </td>
                            <td
                              style={{
                                fontSize: "15px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              :
                            </td>
                            <td
                              style={{
                                fontSize: "15px",
                                textAlign: "start",
                                padding: "8px",
                                color: "black",
                              }}
                            >
                              ₹{globalData.balanceDue}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td colSpan={3}>
                            <div className="tm_invoice_info tm_mb20 mt-2">
                              <div className="tm_invoice_seperator1 tm_gray_bg_dark"></div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td
                            style={{
                              fontSize: "15px",
                              color: "black",
                              fontWeight: "600",
                            }}
                            className="text-end"
                            colSpan="3"
                          >
                            Grand Total: ₹{globalData?.grandtotal}
                          </td>
                        </tr>
                        {/* <tr>
                          <td style={{
                            fontSize: "15px",
                            color: "black",
                            fontWeight:'600'
                          }} className="text-end" colSpan="3">Balance: ₹100</td>
                        </tr> */}
                      </tbody>
                    </table>
                    {Object.keys(taxRows || {})?.length > 0 && (
                      <table
                        width="100%"
                        className=" mt-2"
                        style={{
                          border: "1px solid #c0bebe",
                        }}
                      >
                        <tbody>
                          <tr>
                            <td
                              style={{
                                fontSize: "17px",
                                textAlign: "center",
                                padding: "8px",
                                color: "black",
                                fontWeight: "600",
                              }}
                            >
                              Tax
                            </td>
                            <td
                              style={{
                                fontSize: "17px",
                                textAlign: "center",
                                padding: "8px",
                                color: "black",
                                fontWeight: "600",
                              }}
                            >
                              Amount
                            </td>
                            {isIGST ? (
                              <td
                                style={{
                                  fontSize: "17px",
                                  textAlign: "center",
                                  padding: "8px",
                                  color: "black",
                                  fontWeight: "600",
                                }}
                              >
                                IGST
                              </td>
                            ) : (
                              <>
                                {" "}
                                <td
                                  style={{
                                    fontSize: "17px",
                                    textAlign: "center",
                                    padding: "8px",
                                    color: "black",
                                    fontWeight: "600",
                                  }}
                                >
                                  SGST
                                </td>
                                <td
                                  style={{
                                    fontSize: "17px",
                                    textAlign: "center",
                                    padding: "8px",
                                    color: "black",
                                    fontWeight: "600",
                                  }}
                                >
                                  CGST
                                </td>
                              </>
                            )}
                          </tr>
                          {Object.entries(taxRows || {})
                            .filter(([percent]) => parseFloat(percent) > 0)
                            .map(([percent, t]) => (
                              <tr key={percent}>
                                <td
                                  style={{
                                    fontSize: "15px",
                                    textAlign: "center",
                                    padding: "8px",
                                    color: "black",
                                  }}
                                >
                                  {percent}%
                                </td>
                                <td
                                  style={{
                                    fontSize: "15px",
                                    textAlign: "center",
                                    padding: "8px",
                                    color: "black",
                                  }}
                                >
                                  ₹{t.basePrice}
                                </td>
                                {isIGST ? (
                                  <td
                                    style={{
                                      fontSize: "15px",
                                      textAlign: "center",
                                      padding: "8px",
                                      color: "black",
                                    }}
                                  >
                                    ₹{t.igst}
                                  </td>
                                ) : (
                                  <>
                                    <td
                                      style={{
                                        fontSize: "15px",
                                        textAlign: "center",
                                        padding: "8px",
                                        color: "black",
                                      }}
                                    >
                                      ₹{t.sgst}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "15px",
                                        textAlign: "center",
                                        padding: "8px",
                                        color: "black",
                                      }}
                                    >
                                      ₹{t.cgst}
                                    </td>
                                  </>
                                )}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    )}
                    <table
                      width="100%"
                      cellPadding={2}
                      className=" mt-2 "
                      style={{
                        border: "1px solid #c0bebe",
                      }}
                    >
                      <tbody>
                        <tr className="p-2">
                          <td className="fs-17">YOU SAVED :</td>
                          <td className="fs-17 text-start">
                            ₹{globalData?.totaldiscount}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <table width="100%">
                      <tbody>
                        <tr>
                          <td
                            style={{
                              fontSize: "17px",
                              textAlign: "center",
                              padding: "8px",
                              color: "black",
                            }}
                          >
                            <div className="mt-1 " style={{ fontSize: "17px" }}>
                              Thank you for your purchase
                            </div>
                            {/* <div
                          className="mt-1"
                          style={{ fontSize: "17px", fontWeight: "600" }}
                        >
                          ** Visit us Again **
                        </div> */}
                            {storeSettings?.negobillBranding && (
                              <>
                                <div
                                  className="mt-1"
                                  style={{ fontSize: "17px" }}
                                >
                                  Powered By
                                </div>
                                <div
                                  className="mt-1"
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "600",
                                  }}
                                >
                                  www.NegoBill.com
                                </div>
                              </>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    {/* {terms?.length > 0 && (
                  <table width="100%" style={{ marginLeft: "10px" }}>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            padding: "8px",
                          }}
                        >
                          <div
                            className="fs-13 fw-600"
                            style={{
                              textAlign: "left",
                              color: "black",
                            }}
                          >
                            Terms & Conditions
                          </div>
                          <div className="terms-box">
                          {terms}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="default-content">
            <p>No content available for this sale mode.</p>
          </div>
        )}
      </div>
      {downloadbtn && (
        <div
          className="modal-footer d-block mt-2"
          style={{
            width: "180%",
            position: "sticky",
            bottom: -4,
            background: "#fff",
            zIndex: 10,
            borderTop: "1px solid #e0e0e0",
          }}
        >
          <div className=" d-flex gap-2">
            <div className="btn-group text-right align-items-center">
              {print ? (
                <button
                  className="btn bg-label-animal btn-sm pb-0 font-12"
                  disabled
                >
                  <CircularProgress size={12} className="text-white" />
                </button>
              ) : (
                <>
                  <button
                    onClick={() => handlePrint(data)}
                    className="btn bg-label-animal shadow-none btn-sm font-12"
                    id="printreceiptbtn"
                  >
                    <PrinterIcon iClass={"fs-12"}/> Print
                  </button>
                </>
              )}
            </div>

            {download ? (
              <button
                className="btn btn-warning btn-sm pb-0 text-right"
                disabled
              >
                <CircularProgress size={12} className="text-black" />
              </button>
            ) : (
              <button
                className="btn btn-warning btn-sm text-right"
                id="generatebillpdfbtn"
                onClick={() => handleDownload(data)}
              >
                <DownloadIcon iClass={"fs-15"}/>
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Thermal_2;
